<template>
    <div>
        <!-- <VoiceHintBar ref="voiceHint"
            :question="question"
            :hint="hint"
            :answer="answer"
        /> -->
        <Video ref="video"
            :speechRecognition="speechRecognition"
        />
        <FindingAudio
        
        />
        <audio id='write' :src="require(`@/assets/write.mp3`)" crossorigin="anonymous"></audio>
        <audio id='saved' :src="require(`@/assets/saved.wav`)" crossorigin="anonymous"></audio>
        <audio id='success' :src="require(`@/assets/success.wav`)" crossorigin="anonymous"></audio>
        <audio id='fail' :src="require(`@/assets/fail.mp3`)" crossorigin="anonymous"></audio>
		<audio id='evasgo' :src="require(`@/assets/evasgo_1.wav`)" crossorigin="anonymous"></audio>
        <audio id='insertion2cecum' :src="require(`@/assets/insertion2cecum_1.wav`)" crossorigin="anonymous"></audio>
        <audio id='finish' :src="require(`@/assets/finish_1.wav`)" crossorigin="anonymous"></audio>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VoiceHintBar, { idleQuestion, idleHint} from '@/components/examinations/VoiceHintBar.vue'
import Video from '@/components/examinations/Video.vue'
import FindingAudio from './examinations/findingAudio.vue'
import { MapUIforFinding } from '@/settings/findingUIMap.js'

export default {
    components: {
        VoiceHintBar,
        Video,
        FindingAudio
    },
    data() {
        return {
            question: idleQuestion,
            answer: '',
            hint: idleHint,
            speechRecognitionResult: [],
            runInput: false,
            testInput: '',
            todoAutoInputSpeechRecognitionResultInterval: null,
            isInsertionTo: false,
            photoNum: null,
            colonPolypectomyFocus: false,

            //all 通用指令
            commonCommand: ["delete finding", "finding over", "cancel", "open form", "continue", "back to the list",
                "select", "deselect", "landmark", "remove landmark", "add to finding", "remove from finding", "observation",
                "lesion", "evas go", "insertion to", "withdrawal to splenic flexure", "finish", "preparation agent",
                "cleanse level", "preparation", "incomplete study due to", "add sedatives", "switch to sedatives",
                "delete sedatives", "new location", "delete location", "photo"
            ]
        }
    },
    mounted() {
        this.autoInputSpeechRecognitionResult();
        window.voiceInput = this.addWindowVoiceInput;
    },
    destroyed() {
        if (this.todoAutoInputSpeechRecognitionResultInterval != null) {
            clearInterval(this.todoAutoInputSpeechRecognitionResultInterval);
        }
    },
    computed: {
        ...mapGetters('examinations', [
            'getQuestionsList',
            'getDoctorList',
            'getTechnicalStaffList',
            'getExaminationData',
            'getLandmarkList',
            'getExaminationTypeList',
            'getInspectionInstrumentList',
            'getWashInstrumentList',
            'getCleanMedList',
            'getSedativeList',
            'getPatient',
            'getStoreHiddenParameter',
            'getVoiceCommandTestKeyword'
        ]),
        ...mapGetters([
            'getUser'
        ]),

        getFindings() {
            return this.getExaminationData ? this.getExaminationData.findings : null
        },

        getAllImages() {
            return this.getExaminationData ? this.getExaminationData.all : null
        },

        getImage() {
            return this.getExaminationData.all[this.getStoreHiddenParameter.nowImgIndex]
        },

        examinationID() {
            return this.getExaminationData.examination.id
        },

        accNo() {
            return this.getExaminationData.examination.accNo
        },

        examination_typeID() {
            return this.getExaminationData.examination.examination_typeID
        },

        examinationSedatives() {
            return this.getExaminationData.sedatives
        },

        getFinding() {
            return this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex]
        },

        getRecord() {
            return this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex].records[this.getStoreHiddenParameter.nowRecordIndex]
        },

        examinationLocations() {
            return this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex].records[this.getStoreHiddenParameter.nowRecordIndex].questions.location
        },

        getLocation() {
            return this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex].records[this.getStoreHiddenParameter.nowRecordIndex].questions.location[this.getStoreHiddenParameter.nowLocationsIndex]
        },

        getIntervenValue() {
            return this.getExaminationData.findings[this.getStoreHiddenParameter.nowFindingIndex].records[this.getStoreHiddenParameter.nowRecordIndex].questions.interven.value
        },

        time_start() {
            return this.getExaminationData.examination.time_start
        },

        time_insertion_level() {
            return this.getExaminationData.examination.time_insertion_level
        },

        time_landmark_splenic_flexure() {
            return this.getExaminationData.examination.time_landmark_splenic_flexure
        },

        time_finished() {
            return this.getExaminationData.examination.time_finished
        },

        insertionTime() {
            return this.getExaminationData.examination.insertionTime
        },

        proximalColonWithTime() {
            return this.getExaminationData.examination.proximalColonWithTime
        },

        withdrawTime() {
            return this.getExaminationData.examination.withdrawTime
        },

        totalExamTime() {
            return this.getExaminationData.examination.totalExamTime
        }

    },
    methods: {
        ...mapActions('examinations', [
            'updateExaminationColumn',
            'setExaminationFinishDialog',
            'setStoreHiddenParameter',
            'fetchVoiceCommandTestKeywordArray',
            'setRecording',
            'setTimeCounting',
            'setTimeCountingStep',
            'setTimeFinish',
            'setCommandQueue',
            'popCommandQueue',
            'setCurrentCommand',
            'sendDICOMStructureReport'
        ]),

        musicPlay(voiceinput) {
            let music;
            music = document.getElementById(voiceinput);
            music.play();
        },

        autoInputSpeechRecognitionResult() {
            const _this = this;
            this.todoAutoInputSpeechRecognitionResultInterval = setInterval(() => {
                _this.todoAutoInputSpeechRecognitionResult();
            }, 50);
        },
        todoAutoInputSpeechRecognitionResult() {
            if (this.runInput) {
                this.runInput = false;
                // console.log('todoAutoInputSpeechRecognitionResult #1');
                // console.log(this.speechRecognitionResult);
                this.speechRecognition(this.speechRecognitionResult[0].toLowerCase(), 'test');
                this.speechRecognitionResult.splice(0, 1);
                // console.log('todoAutoInputSpeechRecognitionResult #2');
                // console.log(this.speechRecognitionResult);
            }
        },

        getRecordForHint(questions) {
            let hintArray = []
            console.log('getRecordForHint', questions)
            for (let key in questions) {
                if (key == 'interven') {
                    for (let option in questions[key].config.options) {
                        hintArray.push(questions[key].config.options[option])
                    }
                } else if (key == 'location') {
                    hintArray.push('location')
                } else if (questions[key].config) {
                    hintArray.push(questions[key].config.question)
                }
            }
            return JSON.stringify(hintArray).replace(/\"/g, "")
        },
        setExaminationColumn(column, value) {
            var d = {
                id: this.examinationID,
                column: column,
                value: value
            }
            this.updateExaminationColumn(d)
        },
        addWindowVoiceInput(voiceInputArray) {
            let self = this
            let p = Promise.resolve();
            const API_URL = process.env.VUE_APP_API_URL
            let frontEndLog;
            let url;
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            // voiceInputArray = ["GU","location","angle","orientation","pw","active bleeding","yes"];
            // voiceInputArray = ["intervention","biopsy","apc"];

            // console.log('addWindowVoiceInput #1');
            console.log('->');
            console.log(voiceInputArray);

            for (let i = 0; i < voiceInputArray.length; i++) {
                // setTimeout(function() {
                p = p.then(() => {
                  self.setCommandQueue(voiceInputArray[i]);
                  self.voiceCommand(voiceInputArray[i].toLowerCase()).then(() => {
                    self.setCurrentCommand(voiceInputArray[i]);
                  });
                });

                frontEndLog = new Date().getTime().toString();
                console.log('# voiceCommand: ' + frontEndLog + ' => ' + voiceInputArray[i].toLowerCase());
                if (voiceInputArray[i].toLowerCase() === 'insertion to') {
                    this.isInsertionTo = true
                }           

                let params = JSON.stringify({
                    'frontEndLog': 'voiceCommand: ' + frontEndLog + ' ' + voiceInputArray[i].toLowerCase()
                });
                url = `${API_URL}/frontEndLog?t=` + (new Date()).getTime().toString();
                self.$http.post(url, params, options).then((response) => {
                    // console.log(response);
                });
                // }, (i + 1) * 150)
            }
            // console.log('addWindowVoiceInput #2');
            if (this.speechRecognitionResult.length > 0) {
                this.runInput = true;
            }
            // console.log('runInput: ' + this.runInput);
            return p;
        },
        speechRecognition(recorderData, mode) {			
            if (mode == 'test') {
                this.testInput = recorderData;
            }
            const API_URL = process.env.VUE_APP_API_URL
            const url = `${API_URL}/speech-recognition?t=` + (new Date()).getTime().toString();
            var interven = null;
            if (this.getFinding) {
                if (this.getRecord) {
                    if (this.getRecord.questions.interven) {
                        interven = this.getIntervenValue;
                    }
                }
            }

            const data = this.getExaminationData.examination;
			const params = JSON.stringify({
				translationMode: 'o',
				mode: mode,
				file: recorderData,
				focus: this.getStoreHiddenParameter.focus,
				part: this.getStoreHiddenParameter.nowQuestionPart,
				examinationID: this.examinationID,
				examination_typeID: this.examination_typeID,
				examinationDoctorID: this.getExaminationData.examination.examinationDoctorID,
				startTimestamp: this.$refs.video.startTimestamp,
				endTimestamp: this.$refs.video.endTimestamp,
				finding: this.getFinding ? this.getFinding.questions.finding.value : null,
				interven: interven,
                over: this.getStoreHiddenParameter.over,   
                patient: this.getPatient,
                doctor: data.examinationDoctorID > 1 ? this.getDoctorList.filter(item => item.id === data.examinationDoctorID)[0] : null,
                technician1: data.technical_staffID_1 > 1 ? this.getTechnicalStaffList.filter(item => item.id === data.technical_staffID_1)[0]: null,
                technician2: data.technical_staffID_2 > 1 ? this.getTechnicalStaffList.filter(item => item.id === data.technical_staffID_2)[0]: null
            });
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const _this = this;

            this.$http.post(url, params, options).then((response) => {
                if (mode == 'test') {
                    // console.log('speechRecognition #2');
                    // console.log(response.data.voiceInput);
                    /*if (['test', 'testc'].indexOf(_this.getUser.username) != -1) {
                        if (_this.testInput != response.data.voiceInput[0].toLowerCase()) {
                            if (response.data.voiceInput.length > 1) {
                                if (_this.testInput != response.data.voiceInput[1].toLowerCase()) {
                                    console.log('i/o --------------------');
                                    console.log(_this.testInput + ' i/o ' + response.data.voiceInput[0]);
                                }
                            } else {
                                console.log('i/o --------------------');
                                console.log(_this.testInput + ' i/o ' + response.data.voiceInput[0]);
                            }
                        }
                    }*/
                    _this.addWindowVoiceInput(response.data.voiceInput);
                }
				else if (mode == 'websocket2')
				{}
				else {
                    // console.log('speechRecognition #1');
                    console.log('speechRecognition ####################');
                    console.log(response.data.voiceInput);
                    if (response.data.voiceInput[0] != '') {
                        if (response.data.voiceInput.length === 3 &&  response.data.voiceInput[0] === 'photo' ) {
                            if ( response.data.voiceInput[2] === 'before' || response.data.voiceInput[2] === 'after') {
                                const regex = /^[0-9]*$/g;
                                if (regex.exec(response.data.voiceInput[1]) != null) {
                                    this.photoNum = Number(response.data.voiceInput[1])
                                }
                            }
                        }
                        if (_this.speechRecognitionResult.length == 0) {
                            this.runInput = true;
                        }
                        _this.speechRecognitionResult = _this.speechRecognitionResult.concat(response.data.voiceInput); 
                        //驗證是否為數字
                        let numRegex = /^[1-9][0-9]?$|^100$/
                        if(response.data.voiceInput[1] && !numRegex.exec(response.data.voiceInput[1])){
                            let responseVoiceInput = response.data.voiceInput[1].toLowerCase()
                            _this.musicPlay(`${responseVoiceInput}`)
                            setTimeout(() => { this.musicPlay('success'); }, 300);                   
                        }   
                            setTimeout(() => { this.musicPlay('success'); }, 300);       
                        } 
                        else {
                        _this.musicPlay('fail');
                    }
                }
            }, (response) => {
                console.log(response)
            });
        },
        //////////////////////////////////////////////////
        //※ 語音
        //////////////////////////////////////////////////
        // 設定圖片是否顯示於報告
        // 參考 ExaminationDetailPage.vue 的 toggleImgStatus
        setImgShowInReport(show) {

            if (this.getAllImages != null && this.getImage) {

                var item = this.getImage;
                var newStatus = show;
                var imgID = item.id;
                var findingID = item.findingID;
                var landmarkID = item.landmarkID;
                var obj = {
                    imgID,
                    newStatus,
                    item,
                    findingID,
                    landmarkID
                };

                if (item.findingID !== 0) {
                    this.$store.dispatch('examinations/updateScreenshotStatusInFinding', obj)
                        .then(() => {
                            this.musicPlay('saved');
                        });
                }
                console.log('image -> ' + show ? 'select' : 'deselect');
                this.$store.dispatch('examinations/updateScreenshotStatusInAll', {
                    ...obj,
                    imgIndex: this.getStoreHiddenParameter.nowImgIndex
                }).then(() => this.musicPlay('saved'));;

            }

        },

        // 確認欄位存在並設定 focus
        checkInputExistAndSetFocuse(table, focus, part) {

            if (this.getFinding && (!this.getStoreHiddenParameter.over || focus == "finding")) {

                switch (table) {

                    case "finding":
                        if (this.getFinding.questions[focus]) {
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: focus,
                                part: part
                            });
                            return true;
                        } else {
                            return false;
                        }
                        break;

                    case "record":
                        if (this.getRecord) {
                            if (this.getRecord.questions[focus]) {
                                this.setStoreHiddenParameter({
                                    target: 'focus',
                                    value: focus,
                                    part: part
                                });
                                return true;
                            } else if (this.examinationLocations) {
                                if (this.getLocation.questions[focus]) {
                                    this.setStoreHiddenParameter({
                                        target: 'focus',
                                        value: focus,
                                        part: part
                                    });
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                        break;
                }

            } else {
                return false;
            }

        },

        // 顯示選項提示
        showOptionTip(options) {
            this.hint = JSON.stringify(options).replace(/\"/g, "")
        },


        // 填寫
        writeInput(table, inputType, data) {

            // table, inputType 用不到, 暫時保留
            // table: finding, record
            // inputType: c, c2, s, t, ta, n
            this.musicPlay('write');
            if (!this.getStoreHiddenParameter.over) {

                if (['loca', 'orien', 'dist'].indexOf(this.getStoreHiddenParameter.focus) != -1) {

                    var findingIndex = this.getStoreHiddenParameter.nowFindingIndex
                    var recordIndex = this.getStoreHiddenParameter.nowRecordIndex
                    var field = this.getStoreHiddenParameter.focus
                    var value = data

                    if (['s'].indexOf(inputType) != -1) {
                        if (this.getLocation.questions[field].value != value) {
                            this.getLocation.questions[field].value = value;
                        } else {
                            this.getLocation.questions[field].value = '';
                        }
                        value = this.getLocation.questions[field].value;
                    }

                    var obj = {
                        id: this.getLocation.id,
                        column: field,
                        value: value
                    };

                    // console.log('writeInput: ' + field + ' -> ' + data);
                    this.$store.dispatch('examinations/updateExaminationLocationColumn', {
                        findingIndex: findingIndex,
                        recordIndex: recordIndex,
                        obj
                    }).then(() => {
                        this.musicPlay('saved');
                        // if (typeof (this.getImage) != 'undefined' && (Number(this.getImage.findingID) == 0 || Number(this.getImage.findingID) == Number(this.getFindings[this.getStoreHiddenParameter.nowFindingIndex].id))) {
                        if (typeof(this.getImage) != 'undefined' && Number(this.getImage.findingID) == Number(this.getFindings[this.getStoreHiddenParameter.nowFindingIndex].id)) {

                            var loca = this.getLocation.questions.loca ? this.getLocation.questions.loca.value : ''
                            var orien = this.getLocation.questions.orien ? this.getLocation.questions.orien.value : ''
                            var landmarkID = 0;
                            switch (Number(loca)) {
                                case 296:
                                    landmarkID = 31;
                                    break;
                                case 297:
                                    landmarkID = 32;
                                    break;
                                case 298:
                                    landmarkID = 33;
                                    break;
                                case 299:
                                    landmarkID = 34;
                                    break;
                                case 300:
                                    landmarkID = 35;
                                    break;
                                case 301:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 37;
                                            break;
                                        case 360:
                                            landmarkID = 38;
                                            break;
                                        case 361:
                                            landmarkID = 39;
                                            break;
                                        case 362:
                                            landmarkID = 40;
                                            break;
                                        default:
                                            landmarkID = 36;
                                    }
                                    break;
                                case 302:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 42;
                                            break;
                                        case 360:
                                            landmarkID = 43;
                                            break;
                                        case 361:
                                            landmarkID = 44;
                                            break;
                                        case 362:
                                            landmarkID = 45;
                                            break;
                                        default:
                                            landmarkID = 41;
                                    }
                                    break;
                                case 303:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 47;
                                            break;
                                        case 360:
                                            landmarkID = 48;
                                            break;
                                        case 361:
                                            landmarkID = 49;
                                            break;
                                        case 362:
                                            landmarkID = 50;
                                            break;
                                        default:
                                            landmarkID = 46;
                                    }
                                    break;
                                case 304:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 52;
                                            break;
                                        case 360:
                                            landmarkID = 53;
                                            break;
                                        case 361:
                                            landmarkID = 54;
                                            break;
                                        case 362:
                                            landmarkID = 55;
                                            break;
                                        default:
                                            landmarkID = 51;
                                    }
                                    break;
                                case 305:
                                    landmarkID = 56;
                                    break;
                                case 306:
                                    landmarkID = 57;
                                    break;
                                case 307:
                                    landmarkID = 58;
                                    break;
                                case 308:
                                    landmarkID = 59;
                                    break;
                                case 309:
                                    landmarkID = 60;
                                    break;
                                case 310:
                                    landmarkID = 61;
                                    break;
                                case 528:
                                    landmarkID = 62;
                                    break;
                                case 312:
                                    landmarkID = 1;
                                    break;
                                case 313:
                                    landmarkID = 2;
                                    break;
                                case 314:
                                    landmarkID = 3;
                                    break;
                                case 315:
                                    landmarkID = 4;
                                    break;
                                case 316:
                                    switch (Number(orien)) {
                                        case 324:
                                            landmarkID = 6;
                                            break;
                                        case 325:
                                            landmarkID = 7;
                                            break;
                                        case 326:
                                            landmarkID = 8;
                                            break;
                                        default:
                                            landmarkID = 5;
                                    }
                                    break;
                                case 317:
                                    landmarkID = 9;
                                    break;
                                case 318:
                                    switch (Number(orien)) {
                                        case 324:
                                            landmarkID = 11;
                                            break;
                                        case 325:
                                            landmarkID = 12;
                                            break;
                                        case 326:
                                            landmarkID = 13;
                                            break;
                                        default:
                                            landmarkID = 10;
                                    }
                                    break;
                                case 319:
                                    landmarkID = 14;
                                    break;
                                case 320:
                                    switch (Number(orien)) {
                                        case 324:
                                            landmarkID = 16;
                                            break;
                                        case 325:
                                            landmarkID = 17;
                                            break;
                                        case 326:
                                            landmarkID = 18;
                                            break;
                                        default:
                                            landmarkID = 15;
                                    }
                                    break;
                                case 321:
                                    switch (Number(orien)) {
                                        case 324:
                                            landmarkID = 20;
                                            break;
                                        case 325:
                                            landmarkID = 21;
                                            break;
                                        case 326:
                                            landmarkID = 22;
                                            break;
                                        default:
                                            landmarkID = 19;
                                    }
                                    break;
                                case 322:
                                    landmarkID = 23;
                                    break;
                                case 323:
                                    switch (Number(orien)) {
                                        case 325:
                                            landmarkID = 26;
                                            break;
                                        case 327:
                                            landmarkID = 25;
                                            break;
                                        case 328:
                                            landmarkID = 27;
                                            break;
                                        default:
                                            landmarkID = 24;
                                    }
                                    break;
                                case 529:
                                    landmarkID = 28;
                                    break;
                                case 530:
                                    landmarkID = 29;
                                    break;
                                case 563:
                                    landmarkID = 30;
                                    break;
                                case 590:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 64;
                                            break;
                                        case 360:
                                            landmarkID = 65;
                                            break;
                                        case 361:
                                            landmarkID = 66;
                                            break;
                                        case 362:
                                            landmarkID = 67;
                                            break;
                                        default:
                                            landmarkID = 63;
                                    }
                                    break;
                                case 591:
                                    switch (Number(orien)) {
                                        case 359:
                                            landmarkID = 69;
                                            break;
                                        case 360:
                                            landmarkID = 70;
                                            break;
                                        case 361:
                                            landmarkID = 71;
                                            break;
                                        case 362:
                                            landmarkID = 72;
                                            break;
                                        default:
                                            landmarkID = 68;
                                    }
                                    break;
                            }
                            if (landmarkID > 0) {
                                if (this.getAllImages != null && this.getImage) {
                                    var item = this.getImage;
                                    var updateObj = {
                                        imgID: item.id,
                                        newValue: landmarkID,
                                        page: 'e'
                                    };
                                    this.$store.dispatch('examinations/imgLandmarkChange', updateObj).then(() => this.musicPlay('saved'));
                                }
                                /*this.setStoreHiddenParameter({
                                    target: 'focus',
                                    value: ''
                                });
                                if (landmarkID == 14) { // splenic flexure
                                    // 紀錄時間
                                    var time = this.getHHiiss();
                                    var d = {
                                        id: this.examinationID,
                                        column: 'time_landmark_splenic_flexure',
                                        value: time
                                    };
                                    this.updateExaminationColumn(d).then(() => {
                                        if (this.time_insertion_level != '00:00:00' && this.time_landmark_splenic_flexure != '00:00:00') {
                                            this.setExaminationColumn('proximalColonWithTime', this.calculatingTime(this.time_insertion_level, this.time_landmark_splenic_flexure));
                                        }
                                    });
                                }*/
                            }
                            if (field == 'dist') {
                                if (this.getAllImages != null && this.getImage) {
                                    var item = this.getImage;
                                    var updateObj = {
                                        imgID: item.id,
                                        newValue: value,
                                        page: 'e'
                                    };
                                    this.$store.dispatch('examinations/imgCmChange', updateObj).then(() => this.musicPlay('saved'));;
                                }
                            }

                        }

                    });

                } else {

                    // 參考 Gastroscopy.vue 的 saveQuestionInput
                    var finding_fields = ['finding', 'number', 'takeNote'];

                    var findingIndex = this.getStoreHiddenParameter.nowFindingIndex
                    var recordIndex = this.getStoreHiddenParameter.nowRecordIndex
                    var field = this.getStoreHiddenParameter.focus
                    var value = data

                    var d = {
                        examination_typeID: this.examination_typeID,
                        findingIndex,
                        recordIndex,
                        findingID: this.getFindings[findingIndex].id,
                        field,
                        value
                    }

                    if (finding_fields.indexOf(field) == -1) {
                        d.recordID = this.getFindings[findingIndex].records[recordIndex].id
                        if (['c', 'c2'].indexOf(inputType) != -1) {
                            if (this.getFindings[findingIndex].records[recordIndex].questions[field].value.indexOf(value) == -1) {
                                if(this.colonPolypectomyFocus && ['hotSnare', 'coldSnare', 'snare'].indexOf(field) > -1) {
                                    this.getFindings[findingIndex].records[recordIndex].questions[field].value = []
                                }
                                this.getFindings[findingIndex].records[recordIndex].questions[field].value.push(value);
                            } else {
                                this.getFindings[findingIndex].records[recordIndex].questions[field].value.splice(this.getFindings[findingIndex].records[recordIndex].questions[field].value.indexOf(value), 1);
                            }
                            d.value = this.getFindings[findingIndex].records[recordIndex].questions[field].value;
                        }
                        if (['s'].indexOf(inputType) != -1) {
                            if (this.getFindings[findingIndex].records[recordIndex].questions[field].value != value) {
                                this.getFindings[findingIndex].records[recordIndex].questions[field].value = value;
                            } else {
                                this.getFindings[findingIndex].records[recordIndex].questions[field].value = '';
                            }
                            d.value = this.getFindings[findingIndex].records[recordIndex].questions[field].value;
                        }
                    } else {
                        d.recordIndex = null;
                        if (['c', 'c2'].indexOf(inputType) != -1) {
                            if (this.getFindings[findingIndex].questions[field].value.indexOf(value) == -1) {
                                this.getFindings[findingIndex].questions[field].value.push(value);
                            } else {
                                this.getFindings[findingIndex].questions[field].value.splice(this.getFindings[findingIndex].questions[field].value.indexOf(value), 1);
                            }
                            d.value = this.getFindings[findingIndex].questions[field].value;
                        }
                        if (['s'].indexOf(inputType) != -1) {
                            if (this.getFindings[findingIndex].questions[field].value != value) {
                                this.getFindings[findingIndex].questions[field].value = value;
                            } else {
                                this.getFindings[findingIndex].questions[field].value = '';
                            }
                            d.value = this.getFindings[findingIndex].questions[field].value;
                        }
                    }

                    let maneuver = ['coldSnare', 'hotSnare', 'snare']
                    if(field && maneuver.indexOf(field) > -1 && this.getFindings[findingIndex] && this.getFindings[findingIndex].records && this.getFindings[findingIndex].records[recordIndex]){
                        let record =  this.getFindings[findingIndex].records[recordIndex]
                        for(let i = 0; i < maneuver.length; i++){
                            if(record.questions[maneuver[i]] && record.questions[maneuver[i]].value && record.questions[maneuver[i]].value[0]) {
                                let o = {
                                    examination_typeID: this.examination_typeID,
                                    findingIndex,
                                    recordIndex,
                                    findingID: this.getFindings[findingIndex].id,
                                    field: record.questions[maneuver[i]].config.field,
                                    recordID: this.getFindings[findingIndex].records[recordIndex].id,
                                    value: [ null ]
                                }
                                this.$store.dispatch('examinations/updateFindingQuestions', o).then(() => {
                                    this.$store.dispatch('examinations/updateFindingQuestions', d).then(() => {
                                        setTimeout(() => { this.musicPlay('saved'); }, 1500);
                                        if (finding_fields.indexOf(field) != -1) {
                                            if (this.getRecord) {
                                                // this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, this.getStoreHiddenParameter.nowRecordIndex);
                                                this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, 0);
                                            } else {
                                                this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, 0);
                                            }
                                        }
                                    });
                                })
                            }
                        }
                    }else {

                        this.$store.dispatch('examinations/updateFindingQuestions', d).then(() => {
                            setTimeout(() => { this.musicPlay('saved'); }, 1500);
                            if (finding_fields.indexOf(field) != -1) {
                                if (this.getRecord) {
                                    // this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, this.getStoreHiddenParameter.nowRecordIndex);
                                    this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, 0);
                                } else {
                                    this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, 0);
                                }
                            }

                        });
                    }

                }

                if (this.getStoreHiddenParameter.focus == 'interven' && Number(data) == 536) {
                    this.setStoreHiddenParameter({
                        target: 'focus',
                        value: 'intervenOther'
                    });
                } else {
                    this.setStoreHiddenParameter({
                        target: 'focus',
                        value: ''
                    });
                }

            }

        },

        // 設定隱藏參數
        setHiddenParameter(nowFindingIndex, nowRecordIndex) {

            if ((nowFindingIndex == null && nowRecordIndex == null) || nowFindingIndex == -1) {
                this.setStoreHiddenParameter({
                    target: 'focus',
                    value: ''
                });
                this.setStoreHiddenParameter({
                    target: 'nowFindingIndex',
                    value: null
                });
                this.setStoreHiddenParameter({
                    target: 'nowRecordIndex',
                    value: null
                });
                this.setStoreHiddenParameter({
                    target: 'nowLocationsIndex',
                    value: null
                });
            } else {
                if (nowFindingIndex != null) {
                    this.setStoreHiddenParameter({
                        target: 'nowFindingIndex',
                        value: nowFindingIndex
                    });
                }

                if (nowRecordIndex != null) {
                    this.setStoreHiddenParameter({
                        target: 'nowRecordIndex',
                        value: nowRecordIndex
                    });
                }

                const location = this.examinationLocations

                if (location) {
                    if (!location[this.getStoreHiddenParameter.nowLocationsIndex]) {
                        this.setStoreHiddenParameter({
                            target: 'nowLocationsIndex',
                            value: 0
                        });
                    }
                } else {
                    this.setStoreHiddenParameter({
                        target: 'nowLocationsIndex',
                        value: null
                    });
                }
            }

        },

        // 取得 HH:ii:ss
        getHHiiss() {
            var x = new Date();
            //var y = x.getFullYear().toString();
            //var m = (x.getMonth() + 1).toString();
            //var d = x.getDate().toString();
            var h = x.getHours().toString();
            var i = x.getMinutes().toString();
            var s = x.getSeconds().toString();
            //(d.length == 1) && (d = '0' + d);
            //(m.length == 1) && (m = '0' + m);
            (h.length == 1) && (h = '0' + h);
            (i.length == 1) && (i = '0' + i);
            (s.length == 1) && (s = '0' + s);
            var HHiiss = h + ':' + i + ':' + s;
            //console.log(HHiiss);
            return HHiiss;
        },

        // 計算時間
        calculatingTime(a, b) {
            var a = a.split(':');
            var b = b.split(':');
            a = Number(a[0]) * 3600 + Number(a[1]) * 60 + Number(a[2]);
            b = Number(b[0]) * 3600 + Number(b[1]) * 60 + Number(b[2]);
            var c = a - b;
            var HHiiss = '00:00:00';
            if (c > 0) {
                var h = parseInt(c / 3600);
                var i = parseInt((c - (h * 3600)) / 60);
                var s = c - (h * 3600) - (i * 60);
                (String(h).length == 1) && (h = '0' + String(h));
                (String(i).length == 1) && (i = '0' + String(i));
                (String(s).length == 1) && (s = '0' + String(s));
                HHiiss = h + ':' + i + ':' + s;
            }
            //console.log('# ' + HHiiss);
            return HHiiss;
        },

        setQuestionFromInput(voiceInput) {
            let isQuestion = false
            let options = []

            for (let key in this.getQuestionsList) {
                const question = this.getQuestionsList[key].question
                if (question.toLowerCase() == voiceInput || this.commonCommand.indexOf(voiceInput.toLowerCase()) >= 0) {
                    isQuestion = true
                }
            }

            if (isQuestion) {
                this.question = voiceInput
                this.answer = ''
                this.hint = ''
            } else {
                this.answer = ': ' + voiceInput
            }
        },

        // 語音指令
        voiceCommand(voiceInput) {
            return new Promise(async(resolve, reject) => {
                this.setQuestionFromInput(voiceInput);
                //==========================================================================
                //※ 變數
                //==========================================================================
                var option = [];
                switch (voiceInput) {
                    //==========================================================================
                    //※ 第一層 通用指令
                    //==========================================================================
                    case "delete finding": // 移除 Finding
                        if (this.getFindings[this.getStoreHiddenParameter.nowFindingIndex] && !this.getStoreHiddenParameter.over) {
                            var findingID = this.getFindings[this.getStoreHiddenParameter.nowFindingIndex].id;
                            this.$store.dispatch('examinations/deleteFinding', {
                                findingID,
                                findingIndex: this.getStoreHiddenParameter.nowFindingIndex
                            }).then(() => {
                                this.musicPlay('saved');
                                this.setHiddenParameter((this.getExaminationData.findings.length - 1), 0);
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                        break;
                    case "finding over": // 結束 Finding
                        // 設定隱藏參數
                        // this.setHiddenParameter(this.getStoreHiddenParameter.nowFindingIndex, null);
                        this.setStoreHiddenParameter({
                            target: 'over',
                            value: true
                        });
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: ''
                        });
                        resolve();
                        break;
                    case "cancel": // 取消 focus
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: ''
                        });
                        resolve();
                        break;
                    case "open form": // 開啟麻醉清腸表單
                        this.setExaminationFinishDialog(true);
                        resolve();
                        break;
                    case "continue": // 關閉麻醉清腸表單
                        this.setExaminationFinishDialog(false);
                        resolve();
                        break;
                    case "back to the list": // 檢查結束
                        // 更改檢查狀態 -> 已檢查
                        this.setExaminationColumn('status', 2);
                        resolve();

                        // 轉跳到檢查清單
                        this.$router.push({
                            path: `/home`
                        });
                        break;
                    case "select": // 設定截圖 在報告內顯示
                        this.setImgShowInReport('1');
                        resolve();
                        break;
                    case "deselect": // 設定截圖 在報告內不顯示
                        this.setImgShowInReport('0');
                        resolve();
                        break;
                    case "landmark": // 設定截圖 Landmark
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'landmark'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 看是哪個 Landmark
                        resolve();
                        break;
                    case "remove landmark": // 移除截圖 Landmark
                        // 參考 ExaminationDetailPage.vue 的 imgLandmarkChange                        
                        // 依據 nowImgIndex 設定截圖 Landmark
                        if (this.getAllImages != null && this.getImage) {
                            var item = this.getImage;
                            var updateObj = {
                                imgID: item.id,
                                newValue: 0,
                                page: 'e'
                            };
                            this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
                                .then(() => this.musicPlay('saved'));
                        }
                        resolve();
                        break;
                    case "add to finding": // 設定截圖 Finding 分群
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'findingGroup'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 value: 1 ~ n 轉換 (value - 1)
                        resolve();
                        break;
                    case "remove from finding": // 移除截圖 Finding 分群
                        // 參考 ExaminationDetailPage.vue 的 moveImgFromAllToFinding                        
                        // 依據 nowImgIndex 設定截圖 Finding 分群
                        if (this.getAllImages != null && this.getImage) {
                            var item = this.getImage;
                            var newValue = 0;
                            var updateObj = {
                                imgID: item.id,
                                newValue
                            };
                            this.$store.dispatch('examinations/moveImgFromAllToFinding', updateObj)
                                then(() => this.musicPlay('saved'));;
                        }
                        resolve();
                        break;
                    case "observation": // 切換 observation
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'finding',
                            part: 'd'
                        });
                        resolve();
                        break;
                    case "lesion": // 切換 lesion
                        if (!this.getStoreHiddenParameter.over) {
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'switchLesion'
                            });
                            // 等下一個 for 迴圈 -> 第三層 value: 1 ~ n 轉換 (value - 1)
                        }
                        resolve();
                        break;
                    case "evas go": // 紀錄時間
                        this.setTimeCounting(true);
                        this.setTimeCountingStep(1);
                        var time = this.getHHiiss();
                        var d = {
                            id: this.examinationID,
                            column: 'time_start',
                            value: time
                        };
                        this.updateExaminationColumn(d).then(() => {
                            if (this.time_insertion_level != '00:00:00' && this.time_start != '00:00:00') {
                                this.setExaminationColumn('insertionTime', this.calculatingTime(this.time_insertion_level, this.time_start));
                            }
                            if (this.time_finished != '00:00:00' && this.time_start != '00:00:00') {
                                this.setExaminationColumn('totalExamTime', this.calculatingTime(this.time_finished, this.time_start));
                            }
							setTimeout(() => { this.musicPlay('evasgo'); }, 500);
                            resolve();
                        });
                        break;
                    case "photo": // pin which photo
                        console.log('## at photo~~~~')
                        // resolve();
                        break;
                    case "insertion to": // 紀錄時間
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'insertionLevel'
                        });
                        this.setTimeCountingStep(2);
                        var time = this.getHHiiss();
                        var d = {
                            id: this.examinationID,
                            column: 'time_insertion_level',
                            value: time
                        };
                        this.updateExaminationColumn(d).then(() => {
                            if (this.time_insertion_level != '00:00:00' && this.time_start != '00:00:00') {
                                this.setExaminationColumn('insertionTime', this.calculatingTime(this.time_insertion_level, this.time_start));
                            }
                            if (this.time_insertion_level != '00:00:00' && this.time_landmark_splenic_flexure != '00:00:00') {
                                this.setExaminationColumn('proximalColonWithTime', this.calculatingTime(this.time_insertion_level, this.time_landmark_splenic_flexure));
                            }
                            if (this.time_finished != '00:00:00' && this.time_insertion_level != '00:00:00') {
                                this.setExaminationColumn('withdrawTime', this.calculatingTime(this.time_finished, this.time_insertion_level));
                            }
							setTimeout(() => { this.musicPlay('insertion2cecum'); }, 500);
                            // 填寫的部分等下一個 for 迴圈 -> 第三層 this.setExaminationColumn('insertionLevel', this.value);
                            resolve();
                        });
                        break;
                    case "withdrawal to splenic flexure": // 紀錄時間
                        if (this.getAllImages != null && this.getImage) {
                            var item = this.getImage;
                            var updateObj = {
                                imgID: item.id,
                                newValue: 14,
                                page: 'e'
                            };
                            this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
                                .then(() => this.musicPlay('saved'));
                        }
                        this.setTimeCountingStep(3);
                        var time = this.getHHiiss();
                        var d = {
                            id: this.examinationID,
                            column: 'time_landmark_splenic_flexure',
                            value: time
                        };
                        this.updateExaminationColumn(d).then(() => {
                            if (this.time_insertion_level != '00:00:00' && this.time_landmark_splenic_flexure != '00:00:00') {
                                this.setExaminationColumn('proximalColonWithTime', this.calculatingTime(this.time_landmark_splenic_flexure, this.time_insertion_level));
                            }
                            resolve();
                        });
                        break;
                    case "finish": // 紀錄時間
                        this.setTimeFinish(true);
                        this.setTimeCountingStep(4);
                        var time = this.getHHiiss();
                        var d = {
                            id: this.examinationID,
                            column: 'time_finished',
                            value: time
                        };
                        this.updateExaminationColumn(d).then(() => {
                            if (this.time_finished != '00:00:00' && this.time_insertion_level != '00:00:00') {
                                this.setExaminationColumn('withdrawTime', this.calculatingTime(this.time_finished, this.time_insertion_level));
                            }
                            if (this.time_finished != '00:00:00' && this.time_start != '00:00:00') {
                                this.setExaminationColumn('totalExamTime', this.calculatingTime(this.time_finished, this.time_start));
                            }
							setTimeout(() => { this.musicPlay('finish'); }, 500);
                            // 更改檢查狀態 -> 已檢查
                            this.setExaminationColumn('status', 2);
                            this.sendDICOMStructureReport(this.examinationID)
                            resolve();
                        });
                        // this.setExaminationFinishDialog(true);
                        break;
                    case "preparation agent": // 麻醉清腸表單 清腸藥物 clean_medID
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'clean_medID'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 this.setExaminationColumn('clean_medID', this.value);
                        resolve();
                        break;
                    case "cleanse level": // 麻醉清腸表單 cleanScale
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'cleanScale'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 this.setExaminationColumn('cleanScale', this.value);
                        resolve();
                        break;
                    case "preparation": // 胃腸清空程度
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'preparation'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 this.setExaminationColumn('preparation', this.value);
                        resolve();
                        break;
                    case "incomplete study due to": // 麻醉清腸表單 incompleteDue
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'incompleteDue'
                        });
                        // 填寫的部分等下一個 for 迴圈 -> 第三層 this.setExaminationColumn('incompleteDue', this.value);
                        resolve();
                        break;
                    case "add sedatives": // 新增麻醉藥物
                        // 新增一筆 sedatives
                        this.$store.dispatch('examinations/addExaminationSedative', {
                            examinationID: this.examinationID
                        }).then(() => {
                            this.musicPlay('saved');
                            // 設定 nowSedativesIndex
                            this.setStoreHiddenParameter({
                                target: 'nowSedativesIndex',
                                value: (this.examinationSedatives.length - 1)
                            });
                            // 設定 focus
                            this.setStoreHiddenParameter({
                                target: 'focus',
                                value: 'sedative'
                            });
                            // 填寫的部分等下一個 for 迴圈 -> 第三層 看是藥物還是劑量(※判斷是否為數字), 依據 nowSedativesIndex 填寫
                            resolve();
                        });
                        break;
                    case "switch to sedatives": // 切換麻醉藥物
                        this.setStoreHiddenParameter({
                            target: 'focus',
                            value: 'switchSedative'
                        });
                        // 等下一個 for 迴圈 -> 第三層 value: 1 ~ n 轉換 (value - 1), 設定 nowSedativesIndex, 設定 focus
                        resolve();
                        break;
                    case "delete sedatives": // 刪除麻醉藥物
                        if (this.examinationSedatives[this.getStoreHiddenParameter.nowSedativesIndex]) {
                            // 依據 nowSedativesIndex 刪除麻醉藥物
                            this.$store.dispatch('examinations/deleteExaminationSedative', {
                                examinationSedativeID: this.examinationSedatives[this.getStoreHiddenParameter.nowSedativesIndex].id
                            }).then(() => {
                                this.musicPlay('saved');
                                // 設定 nowSedativesIndex
                                this.setStoreHiddenParameter({
                                    target: 'nowSedativesIndex',
                                    value: (this.examinationSedatives.length - 1) != -1 ? (this.examinationSedatives.length - 1) : null
                                });
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                        break;
                    case "new location": // 新增 location
                        if (!this.getStoreHiddenParameter.over) {
                            if (this.getRecord) {
                                // 新增一筆 locations
                                this.$store.dispatch('examinations/addExaminationLocation', {
                                    recordID: this.getRecord.id,
                                    findingIndex: this.getStoreHiddenParameter.nowFindingIndex
                                }).then(() => {
                                    this.musicPlay('saved');
                                    // 設定 nowLocationsIndex
                                    this.setStoreHiddenParameter({
                                        target: 'nowLocationsIndex',
                                        value: (this.examinationLocations.length - 1)
                                    });
                                    // 設定 focus
                                    this.setStoreHiddenParameter({
                                        target: 'focus',
                                        value: 'loca'
                                    });
                                    // 填寫的部分等下一個 for 迴圈 -> 第三層 看是哪個 location, orientation 依據 nowLocationsIndex 填寫
                                    resolve();
                                });
                            }
                        } else {
                            resolve();
                        }
                        break;
                    case "delete location": // 刪除 location
                        if (this.examinationLocations.length > 1 && this.getLocation && !this.getStoreHiddenParameter.over) {
                            // 依據 nowLocationsIndex 刪除 location
                            this.$store.dispatch('examinations/deleteExaminationLocation', {
                                locationID: this.getLocation.id,
                                recordIndex: this.getStoreHiddenParameter.nowRecordIndex,
                                findingIndex: this.getStoreHiddenParameter.nowFindingIndex
                            }).then(() => {
                                this.musicPlay('saved');
                                // 設定 nowLocationsIndex
                                this.setStoreHiddenParameter({
                                    target: 'nowLocationsIndex',
                                    value: (this.examinationLocations.length - 1) != -1 ? (this.examinationLocations.length - 1) : null
                                });
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                        break;
                    
                    case "before":
                        // if last Image is before, then cancel lastImage's before
                        let thisImgObj = {
                            imgID: this.getImage.id,
                            tag: "before",
                            findingID: this.getFinding.id,
                            page: 'e'
                        }
                        if (this.getAllImages.length > 0) {
                            let thisImgIndex = 0
                            if(this.getAllImages[0].file === null) {
                                if(this.photoNum - 1 > 0 && this.photoNum <= this.getAllImages.length) {
                                    thisImgIndex = this.photoNum - 1
                                }
                            }else { // thi.getAllImage at least 1 and not null
                                if ((this.photoNum) && this.photoNum - 1 <= this.getAllImages.length - 1) {
                                    thisImgIndex = this.photoNum - 1
                                }
                            }

                            if(this.photoNum) {
                                this.photoNum = null
                            }
                            
                            const thisImg = this.getAllImages[thisImgIndex];
                            thisImgObj.imgID = thisImg.id
                            thisImgObj.findingID = thisImg.findingID
                              
                            if (thisImg && thisImg.tag === 'before') {
                                thisImgObj.tag = null                            
                            }
                        } 

                        this.$store.dispatch('examinations/imgTagChange', thisImgObj)
                            .then(() => {
                                this.musicPlay('saved')
                                console.log('successed to save img: ',thisImgObj,' with BEFORE')
                            });
                        break;

                    case "after":
                        // if last image is before, then we add after
                        thisImgObj = {
                            imgID: this.getImage.id,
                            tag: "after",
                            findingID: this.getFinding.id,
                            page: 'e'
                        }
                        if (this.getAllImages.length > 0) {
                            let thisImgIndex = 0
                            if(this.getAllImages[0].file === null) {
                                if(this.photoNum - 1 > 0 && this.photoNum <= this.getAllImages.length) {
                                    thisImgIndex = this.photoNum - 1
                                }
                            }else { // thi.getAllImage at least 1 and not null
                                if ((this.photoNum) && this.photoNum - 1 <= this.getAllImages.length - 1) {
                                    thisImgIndex = this.photoNum - 1
                                }
                            }

                            if(this.photoNum) {
                                this.photoNum = null
                            }
                            
                            const thisImg = this.getAllImages[thisImgIndex];
                            thisImgObj.imgID = thisImg.id
                            thisImgObj.findingID = thisImg.findingID
                              
                            if (thisImg && thisImg.tag === 'after') {
                                thisImgObj.tag = null                            
                            }
                        } 

                        this.$store.dispatch('examinations/imgTagChange', thisImgObj)
                            .then(() => {
                                this.musicPlay('saved')
                                console.log('successed to save img: ',thisImgObj,' with AFTER')
                            });

                        break;

                    // 填表快捷指令
                    case "gerd a":
                    case "gerd b":  
                    case "gerd c":
                    case "gerd d":
                        if (Number(this.getFinding.questions.finding.value) != 1) {
                            window.voiceInput(['finding', 'Gerd']);
                        }
                        const grade = voiceInput.substr(5, 1);
                        
                        setTimeout(() => {
                            window.voiceInput(["l.a. grade", grade])
                        },1000)
                    
                        setTimeout(() => {
                            window.voiceInput(["finding over"])
                        }, 1500)
                        break;
                    
                    default:
                        //==========================================================================
                        //※ 第二層 指定欄位
                        //==========================================================================
                        var findingIndex = this.getStoreHiddenParameter.nowFindingIndex
                        var recordIndex = this.getStoreHiddenParameter.nowRecordIndex
                        switch (voiceInput) {
                            case "active bleeding":
                                // active bleeding (no.1) (yes, no)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "bleTen":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 179);
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 179);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 179);
                                                }
                                                break;
                                        }
                                        break;
                                    case "des":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([21, 22, 551, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 48, 579, 580, 581, 582, 583, 584, 585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 235);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([21, 22, 551, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 48, 579, 580, 581, 582, 583, 584, 585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 235);
                                                }
                                                break;
                                        }
                                        break;
                                    case "finding":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                this.writeInput("finding", "s", "586");
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                this.writeInput("finding", "s", "586");
                                                break;                                                                              
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "actBle", "d")) {
                                            option = ["yes", "no"];
                                            this.showOptionTip(option);
                                        }
                                }
                                resolve();
                                break;
                            case "bleeding tendency":
                                // bleeding tendency (no.1) (recent bleeding, blood oozing, active bleeding)
                                // bleeding tendency (no.2) (active bleeding, nipple sign)
                                if (this.checkInputExistAndSetFocuse("record", "bleTen", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // bleeding tendency (no.2)
                                                option = ["active bleeding", "nipple sign"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // bleeding tendency (no.1)
                                                option = ["recent bleeding", "blood oozing", "active bleeding"];
                                            }
                                            break;
                                        case 3: // copy from case = '2' (Colonoscopy)
                                            if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // bleeding tendency (no.1)
                                                option = ["recent bleeding", "blood oozing", "active bleeding"];
                                            }
                                            break;                                           
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "borrmann":
                                // Borrmann (no.1) (1, 2, 3, 4)
                                if (this.checkInputExistAndSetFocuse("record", "borr", "d")) {
                                    option = ["1", "2", "3", "4"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "chromo and magnify":
                                // chromo and magnify (no.1) (acetic acid, NBI, BLI, Lugol's solution, indigo carmine, magnification)
                                if (this.checkInputExistAndSetFocuse("record", "chroMag", "d")) {
                                    option = ["acetic acid", "NBI", "BLI", "Lugol's solution", "indigo carmine", "magnification"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "chromo sign":
                                // chromo sign (no.1) (silver sign, pink-color sign, brownish color, light color, lugol-voiding)
                                if (this.checkInputExistAndSetFocuse("record", "chroSign", "d")) {
                                    option = ["silver sign", "pink-color sign", "brownish color", "light color", "lugol-voiding"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "color":
                                // color (no.1) (white, blue)
                                if (this.checkInputExistAndSetFocuse("record", "color", "d")) {
                                    option = ["white", "blue"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "consult surgeon":
                                // consult surgeon (no.1) (yes, no)
                                // consult surgeon (no.2) (yes, no)
                                if (this.checkInputExistAndSetFocuse("record", "conSur", "i")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            switch (Number(this.getFinding.questions.finding.value)) {
                                                case 5:
                                                    if ([519, 520, 521].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 6:
                                                    if ([522, 523].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 1:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 2:
                                                    if ([53, 61, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 4:
                                                    if ([53, 60, 61, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 7:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 8:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 9:
                                                    if ([53, 59, 60, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 10:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 11:
                                                    if ([53, 58, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 12:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 14:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 15:
                                                    if ([53, 60, 61, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 16:
                                                    if ([53, 58, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 39:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 40:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 41:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 42:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 43:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 45:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 46:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 47:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 565:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 566:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 567:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 568:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 569:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 570:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 571:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 572:
                                                    if ([53, 59, 60, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 573:
                                                    if ([53, 59, 60, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 540:
                                                    if ([53, 59, 60, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 574:
                                                    if ([53, 59, 60, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // consult surgeon (no.1)
                                                option = ["yes", "no"];
                                            }
                                            switch (Number(this.getFinding.questions.finding.value)) {
                                                case 34:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 9:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 17:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 18:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 19:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 20:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 21:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 22:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 23:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 24:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 25:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 26:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 27:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 28:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 29:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 30:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 31:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 32:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 33:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 38:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 10:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 39:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 40:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 41:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 42:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 43:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 44:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 45:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 46:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 47:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 50:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 52:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 57:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 540:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 541:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 542:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 543:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 544:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 545:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 546:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 547:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 549:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 550:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 551:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 552:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 553:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 558:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 560:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 35:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 36:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 48:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 561:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 548:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 37:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 564:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 575:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 576:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 577:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 578:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 579:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 580:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 581:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 582:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 583:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 584:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 585:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 586:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                            }
                                            break;
                                        case 3: // copy from case = '2' (Colonoscopy)
                                            if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // consult surgeon (no.1)
                                                option = ["yes", "no"];
                                            }
                                            switch (Number(this.getFinding.questions.finding.value)) {
                                                case 34:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 9:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 17:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 18:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 19:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 20:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 21:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 22:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 23:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 24:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 25:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 26:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 27:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 28:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 29:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 30:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 31:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 32:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 33:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 38:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 10:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 39:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 40:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 41:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 42:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 43:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 44:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 45:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 46:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 47:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 50:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 52:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 57:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 540:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 541:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 542:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 543:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 544:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 545:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 546:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 547:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 549:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 550:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 551:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 552:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 553:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 558:
                                                    if ([53, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 560:
                                                    if ([53, 58, 71, 73].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 35:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 36:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 48:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 561:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 548:
                                                    if ([53, 59, 60, 61, 71, 73, 74, 75, 76].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 37:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 564:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 575:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 576:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 577:
                                                    if ([524, 525, 526].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 578:
                                                    if ([58, 65].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 579:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 580:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 581:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 582:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 583:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 584:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 585:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                                case 586:
                                                    if ([58].indexOf(Number(this.getIntervenValue)) != -1) { // consult surgeon (no.2)
                                                        option = ["yes", "no"];
                                                    }
                                                    break;
                                            }
                                            break;                                            
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "demarcation line":
                                // demarcation line (no.1) (present, absent)
                                if (this.checkInputExistAndSetFocuse("record", "demarc", "d")) {
                                    option = ["present", "absent"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "description":
                                // description (no.1) (edema, erythema, friability, exudate, flat erosion, raised erosion, nodularity, rugal hypertrophy, gastric fold hypertrophy, rugal atrophy, gastric mucosa atrophy, visibility of vascular pattern, intramural bleeding spots, intestinal metaplasia, diffuse redness, erosions)
                                // description (no.2) (elastic, soft, hard, pillow sign, yellow, ulcerative)
                                // description (no.3) (erythema, friability, exudate, tiny, small, giant, shallow, broad, spotted, scattered, confluent, focal, continuous-lesion, skip-lesion, blood oozing, active bleeding, mucus plaque, swelling mucosa, partial obstruction, nearly complete obstruction, complete obstruction, ischemia, necrosis, inflammation, overlying membrane, abscess, recent bleeding)
                                // description (no.4) (erythema, friability, exudate, blood oozing, active bleeding, mucus plaque, swelling mucosa, partial obstruction, nearly complete obstruction, complete obstruction, ischemia, necrosis, inflammation, overlying membrane, abscess, recent bleeding)
                                // description (no.5) (active bleeding, hematin, tarry stool, fresh blood)
                                // description (no.6) (description)
                                // description (no.7) (active bleeding, tarry stool, fresh blood)
                                // description (no.8) (active bleeding, hematin, fresh blood)
                                // description (no.9) (active bleeding, hematin, tarry stool)
                                // description (no.10) (hematin, tarry stool, fresh blood)
                                if (this.checkInputExistAndSetFocuse("record", "des", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([8, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.1)
                                                option = ["edema", "erythema", "friability", "exudate", "flat erosion", "raised erosion", "nodularity", "rugal hypertrophy", "gastric fold hypertrophy", "rugal atrophy", "gastric mucosa atrophy", "visibility of vascular pattern", "intramural bleeding spots", "intestinal metaplasia", "diffuse redness", "erosions"];
                                            } else if ([10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.2)
                                                option = ["elastic", "soft", "hard", "pillow sign", "yellow", "ulcerative"];
                                            } else if ([13, 559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.6)
                                                option = ["description"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.2)
                                                option = ["elastic", "soft", "hard", "pillow sign", "yellow", "ulcerative"];
                                            } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.3)
                                                option = ["erythema", "friability", "exudate", "tiny", "small", "giant", "shallow", "broad", "spotted", "scattered", "confluent", "focal", "continuous-lesion", "skip-lesion", "blood oozing", "active bleeding", "mucus plaque", "swelling mucosa", "partial obstruction", "nearly complete obstruction", "complete obstruction", "ischemia", "necrosis", "inflammation", "overlying membrane", "abscess", "recent bleeding"];
                                            } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.4)
                                                option = ["erythema", "friability", "exudate", "blood oozing", "active bleeding", "mucus plaque", "swelling mucosa", "partial obstruction", "nearly complete obstruction", "complete obstruction", "ischemia", "necrosis", "inflammation", "overlying membrane", "abscess", "recent bleeding"];
                                            } else if ([48, 579, 580, 581, 582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.5)
                                                option = ["active bleeding", "hematin", "tarry stool", "fresh blood"];
                                            } else if ([554, 555, 556, 557, 558, 559, 560, 561, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.6)
                                                option = ["description"];
                                            } else if ([583].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.7)
                                                option = ["active bleeding", "tarry stool", "fresh blood"];
                                            } else if ([584].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.8)
                                                option = ["active bleeding", "hematin", "fresh blood"];
                                            } else if ([585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.9)
                                                option = ["active bleeding", "hematin", "tarry stool"];
                                            } else if ([586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.10)
                                                option = ["hematin", "tarry stool", "fresh blood"];
                                            }
                                            break;
                                        case 3: // copy from case = '2' (Colonoscopy)
                                            if ([10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.2)
                                                option = ["elastic", "soft", "hard", "pillow sign", "yellow", "ulcerative"];
                                            } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.3)
                                                option = ["erythema", "friability", "exudate", "tiny", "small", "giant", "shallow", "broad", "spotted", "scattered", "confluent", "focal", "continuous-lesion", "skip-lesion", "blood oozing", "active bleeding", "mucus plaque", "swelling mucosa", "partial obstruction", "nearly complete obstruction", "complete obstruction", "ischemia", "necrosis", "inflammation", "overlying membrane", "abscess", "recent bleeding"];
                                            } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.4)
                                                option = ["erythema", "friability", "exudate", "blood oozing", "active bleeding", "mucus plaque", "swelling mucosa", "partial obstruction", "nearly complete obstruction", "complete obstruction", "ischemia", "necrosis", "inflammation", "overlying membrane", "abscess", "recent bleeding"];
                                            } else if ([48, 579, 580, 581, 582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.5)
                                                option = ["active bleeding", "hematin", "tarry stool", "fresh blood"];
                                            } else if ([554, 555, 556, 557, 558, 559, 560, 561, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.6)
                                                option = ["description"];
                                            } else if ([583].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.7)
                                                option = ["active bleeding", "tarry stool", "fresh blood"];
                                            } else if ([584].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.8)
                                                option = ["active bleeding", "hematin", "fresh blood"];
                                            } else if ([585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.9)
                                                option = ["active bleeding", "hematin", "tarry stool"];
                                            } else if ([586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // description (no.10)
                                                option = ["hematin", "tarry stool", "fresh blood"];
                                            }
                                            break;                                            
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "device":
                                // device (no.1) (removal forceps, pentapod grasping forceps, grasping forceps, alligator, net, snare)
                                if (this.checkInputExistAndSetFocuse("record", "dev", "d")) {
                                    option = ["removal forceps", "pentapod grasping forceps", "grasping forceps", "alligator", "net", "snare"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "distance":
                                // distance (no.1) (cm)
                                if (this.checkInputExistAndSetFocuse("record", "dist", "d")) {
                                    option = ["cm"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "early or advanced":
                                // early or advanced (no.1) (early, advanced)
                                if (this.checkInputExistAndSetFocuse("record", "earlyAdv", "d")) {
                                    option = ["early", "advanced"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "finding":
                                // finding (no.1) (GERD, Barrett's esophagus, hiatal hernia, esophageal CA, esophageal varices, gastric varices, GU, gastritis, polyp, subepithelial tumor, gastric CA, DU, bulbitis, brunner's gland hyperplasia, esophageal dysplasia, gastric dysplasia, lipoma, carcinoid tumor, GIST, metastatic tumor, extraluminal impression, NET, lymphoma, hemangioma, hyperplastic polyp, operation scar, reflux esophagitis, acute gastritis, hemorrhagic gastritis, chronic gastritis, superficial gastritis, atrophic gastritis, portal hypertensive gastropathy, fundal gland polyp, adenomatous polyp, FAP, scar, anastomosis, total gastrectomy, subtotal gastrectomy, stich, stitches)
                                // finding (no.2) (polyp, subepithelial tumor, tumor, lateral spreading tumor, flat tumor, cancer, ulcer, erosion, colitis, IBD, ulcerative colitis, Crohn's disease, pseudomembranous colitis, ischemic colitis, infectious colitis, TB colitis, amoebic colitis, radiation colitis, proctitis, hemorrhoid, diverticulum, diverticula, diverticulosis, xanthoma, lipoma, carcinoid tumor, GIST, metastatic tumor, extraluminal impression, appendiceal tumor, NET, lymphoma, hemangioma, GI bleeding, melanosis coli, ileitis, foreign body, lymphoid hyperplasia, polypoid tumor, hyperplastic polyp, Peutz-Jeghers syndrome, Juvenile polyp, tubular adenoma, tubulovillous adenoma, villous adenoma, sessile serrated adenoma, traditional serrated adenoma, inflammatory adenoma, early colorectal cancer, advanced colorectal cancer, TB related lesion, non-specific colitis, lymphangioma, bechet's disease, s/p partial colectomy, situs inversus, colonic wall cyst, lymphoid follicles, operation scar, suture granuloma, petechia, diverticulitis, internal hemorrhoid, external hemorrhoid, mixed hemorrhoid, diverticular bleeding, upper GI bleeding, lower GI bleeding, occult bleeding, unknown bleeder, hematin, tarry stool, fresh blood, active bleeding, scar, anastomosis, stich, right hemicolectomy, left hemicolectomy, stitches)
                                if (this.checkInputExistAndSetFocuse("finding", "finding", "f")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            option = ["GERD", "Barrett's esophagus", "hiatal hernia", "esophageal CA", "esophageal varices", "gastric varices", "GU", "gastritis", "polyp", "subepithelial tumor", "gastric CA", "DU", "bulbitis", "brunner's gland hyperplasia", "esophageal dysplasia", "gastric dysplasia", "lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "NET", "lymphoma", "hemangioma", "hyperplastic polyp", "operation scar", "reflux esophagitis", "acute gastritis", "hemorrhagic gastritis", "chronic gastritis", "superficial gastritis", "atrophic gastritis", "portal hypertensive gastropathy", "fundal gland polyp", "adenomatous polyp", "FAP", "scar", "anastomosis", "total gastrectomy", "subtotal gastrectomy", "stich", "stitches"];
                                            break;
                                        case 2: // Colonoscopy
                                            option = ["polyp", "subepithelial tumor", "tumor", "lateral spreading tumor", "flat tumor", "cancer", "ulcer", "erosion", "colitis", "IBD", "ulcerative colitis", "Crohn's disease", "pseudomembranous colitis", "ischemic colitis", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "proctitis", "hemorrhoid", "diverticulum", "diverticula", "diverticulosis", "xanthoma", "lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "appendiceal tumor", "NET", "lymphoma", "hemangioma", "GI bleeding", "melanosis coli", "ileitis", "foreign body", "lymphoid hyperplasia", "polypoid tumor", "hyperplastic polyp", "Peutz-Jeghers syndrome", "Juvenile polyp", "tubular adenoma", "tubulovillous adenoma", "villous adenoma", "sessile serrated adenoma", "traditional serrated adenoma", "inflammatory adenoma", "early colorectal cancer", "advanced colorectal cancer", "TB related lesion", "non-specific colitis", "lymphangioma", "bechet's disease", "s/p partial colectomy", "situs inversus", "colonic wall cyst", "lymphoid follicles", "operation scar", "suture granuloma", "petechia", "diverticulitis", "internal hemorrhoid", "external hemorrhoid", "mixed hemorrhoid", "diverticular bleeding", "upper GI bleeding", "lower GI bleeding", "occult bleeding", "unknown bleeder", "hematin", "tarry stool", "fresh blood", "active bleeding", "scar", "anastomosis", "stich", "right hemicolectomy", "left hemicolectomy", "stitches"];
                                            break;
                                        case 3: // Sigmoidoscopy
                                            option = ["polyp", "subepithelial tumor", "tumor", "lateral spreading tumor", "flat tumor", "cancer", "ulcer", "erosion", "colitis", "IBD", "ulcerative colitis", "Crohn's disease", "pseudomembranous colitis", "ischemic colitis", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "proctitis", "hemorrhoid", "diverticulum", "diverticula", "diverticulosis", "xanthoma", "lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "appendiceal tumor", "NET", "lymphoma", "hemangioma", "GI bleeding", "melanosis coli", "ileitis", "foreign body", "lymphoid hyperplasia", "polypoid tumor", "hyperplastic polyp", "Peutz-Jeghers syndrome", "Juvenile polyp", "tubular adenoma", "tubulovillous adenoma", "villous adenoma", "sessile serrated adenoma", "traditional serrated adenoma", "inflammatory adenoma", "early colorectal cancer", "advanced colorectal cancer", "TB related lesion", "non-specific colitis", "lymphangioma", "bechet's disease", "s/p partial colectomy", "situs inversus", "colonic wall cyst", "lymphoid follicles", "operation scar", "suture granuloma", "petechia", "diverticulitis", "internal hemorrhoid", "external hemorrhoid", "mixed hemorrhoid", "diverticular bleeding", "upper GI bleeding", "lower GI bleeding", "occult bleeding", "unknown bleeder", "hematin", "tarry stool", "fresh blood", "active bleeding", "scar", "anastomosis", "stich", "right hemicolectomy", "left hemicolectomy", "stitches"];
                                            break;
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "form":
                                // form (no.1) (F1, F2, F3)
                                if (this.checkInputExistAndSetFocuse("record", "form", "d")) {
                                    option = ["F1", "F2", "F3"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "forrest":
                                // Forrest (no.1) (Ia, Ib, IIa, IIb, IIc, III)
                                if (this.checkInputExistAndSetFocuse("record", "forrest", "d")) {
                                    option = ["Ia", "Ib", "IIa", "IIb", "IIc", "III"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "grade":
                                // grade (no.1) (I, II, III, IV)
                                if (this.checkInputExistAndSetFocuse("record", "grade", "d")) {
                                    option = ["I", "II", "III", "IV"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "hill":
                                // Hill (no.1) (I, II, III, IV)
                                if (this.checkInputExistAndSetFocuse("record", "hill", "d")) {
                                    option = ["I", "II", "III", "IV"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "invasion depth":
                                // invasion depth (no.1) (mucosa, submucosa, serosa)
                                if (this.checkInputExistAndSetFocuse("record", "invaDep", "undefined")) {
                                    option = ["mucosa", "submucosa", "serosa"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "jes":
                                // JES (no.1) (a, B1, B2, B3)
                                if (this.checkInputExistAndSetFocuse("record", "jes", "d")) {
                                    option = ["a", "B1", "B2", "B3"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "jnet":
                                // JNET (no.1) (1, 2A, 2B, 3)
                                if (this.checkInputExistAndSetFocuse("record", "jnet", "d")) {
                                    option = ["1", "2A", "2B", "3"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "kudo":
                                // Kudo (no.1) (I, II, IIIs, IIIL, IV, V)
                                if (this.checkInputExistAndSetFocuse("record", "kudo", "d")) {
                                    option = ["I", "II", "IIIs", "IIIL", "IV", "V"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "l.a. grade":
                                // L.A. grade (no.1) (a, b, c, d)
                                if (this.checkInputExistAndSetFocuse("record", "laGrade", "d")) {
                                    option = ["a", "b", "c", "d"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "location":
                                // location (no.1) (cervical, upper, middle, lower, ECJ)
                                // location (no.2) (antrum, low-body, mid-body, high-body, angle, cardia, fundus, body, upper-body)
                                // location (no.3) (antrum, low-body, mid-body, high-body, angle, cardia, fundus, bulb, SDA, 2nd portion, body, upper-body)
                                // location (no.4) (bulb, SDA, 2nd portion, papilla)
                                // location (no.5) (high-body, cardia, fundus, upper-body)
                                // location (no.6) (terminal ileum, ileocecal valve, appendix orifice, cecum, ascending colon, hepatic flexure, transverse colon, splenic flexure, descending colon, sigmoid colon, RS junction, rectum, anus, all segments of colon, anastomosis)
                                // location (no.7) (internal, external, mixed)
                                // location (no.8) (cervical, upper, middle, lower, ECJ, antrum, low-body, mid-body, high-body, angle, cardia, fundus, bulb, SDA, 2nd portion, papilla, body, upper-body)
                                if (this.checkInputExistAndSetFocuse("record", "loca", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([4, 5, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.1)
                                                option = ["cervical", "upper", "middle", "lower", "ECJ"];
                                            } else if ([7, 8, 11, 16, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.2)
                                                option = ["antrum", "low-body", "mid-body", "high-body", "angle", "cardia", "fundus", "body", "upper-body"];
                                            } else if ([9, 10, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.3)
                                                option = ["antrum", "low-body", "mid-body", "high-body", "angle", "cardia", "fundus", "bulb", "SDA", "2nd portion", "body", "upper-body"];
                                            } else if ([12, 14].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.4)
                                                option = ["bulb", "SDA", "2nd portion", "papilla"];
                                            } else if ([6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.5)
                                                option = ["high-body", "cardia", "fundus", "upper-body"];
                                            } else if ([559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.8)
                                                option = ["cervical", "upper", "middle", "lower", "ECJ", "antrum", "low-body", "mid-body", "high-body", "angle", "cardia", "fundus", "bulb", "SDA", "2nd portion", "papilla", "body", "upper-body"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.6)
                                                option = ["terminal ileum", "ileocecal valve", "appendix orifice", "cecum", "ascending colon", "hepatic flexure", "transverse colon", "splenic flexure", "descending colon", "sigmoid colon", "RS junction", "rectum", "anus", "all segments of colon", "anastomosis"];
                                            } else if ([34].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.7)
                                                option = ["internal", "external", "mixed"];
                                            }
                                            break;
                                        case 3: // copy from case = '2' (Colonoscopy)
                                            if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.6)
                                                option = ["terminal ileum", "ileocecal valve", "appendix orifice", "cecum", "ascending colon", "hepatic flexure", "transverse colon", "splenic flexure", "descending colon", "sigmoid colon", "RS junction", "rectum", "anus", "all segments of colon", "anastomosis"];
                                            } else if ([34].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // location (no.7)
                                                option = ["internal", "external", "mixed"];
                                            }
                                            break;
                                        
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "hot_snare":
                            case "hot snare":
                                // hot snare (no.1) (hot snare)
                                    if(this.colonPolypectomyFocus || this.getFindings[findingIndex].records[recordIndex].questions['interven'].value === "59"){
                                    if (this.checkInputExistAndSetFocuse("record", "hotSnare", "i")) {
                                        this.writeInput("record", "c2", 63);
                                    }
                                }else{
                                    switch (this.getStoreHiddenParameter.focus) {
                                        case "interven":
                                            switch (Number(this.examination_typeID)) {
                                                case 1: // Gastroscopy
                                                    if ([9, 572, 573, 540, 574, 11, 16, 10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "76");
                                                    }
                                                    break;
                                                case 2: // Colonoscopy
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "76");
                                                    }
                                                    break;
                                                case 3: // copy from case = '2' (Colonoscopy)
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "76");
                                                    }
                                                    break;    
                                                break;    
                                                    break;    
                                            }
                                            break;
                                        default:
                                            if (this.checkInputExistAndSetFocuse("record", "hotSnare", "i")) {
                                                this.writeInput("record", "c2", 63);
                                            }
                                    }
                                }
                                resolve();
                                break;
                            case "emergent":
                                // emergent (no.1) (emergent)
                                if (this.checkInputExistAndSetFocuse("record", "emer", "i")) {
                                    this.writeInput("record", "c2", 64);
                                }
                                resolve();
                                break;
                            case "mayo score":
                                // Mayo score (no.1) (0, 1, 2, 3)
                                if (this.checkInputExistAndSetFocuse("record", "mayo", "d")) {
                                    option = ["0", "1", "2", "3"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "morphology":
                                // morphology (no.1) (0, 0-Ip, 0-Is, 0-IIa, 0-IIb, 0-IIc, 0-III, IIa+c, IIc+a, IIc+III, LST-G, LST-NG, I-sp)
                                // morphology (no.2) (IIa+c, IIc+a, Ip, Is, IIa, IIb, IIc, IIc+III, III, I-sp)
                                if (this.checkInputExistAndSetFocuse("record", "morph", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // morphology (no.2)
                                                option = ["IIa+c", "IIc+a", "Ip", "Is", "IIa", "IIb", "IIc", "IIc+III", "III", "I-sp"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // morphology (no.1)
                                                option = ["0", "0-Ip", "0-Is", "0-IIa", "0-IIb", "0-IIc", "0-III", "IIa+c", "IIc+a", "IIc+III", "LST-G", "LST-NG", "I-sp"];
                                            }
                                            break;
                                        case 3: // copy from case = '2' (Colonoscopy)
                                            if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // morphology (no.1)
                                                option = ["0", "0-Ip", "0-Is", "0-IIa", "0-IIb", "0-IIc", "0-III", "IIa+c", "IIc+a", "IIc+III", "LST-G", "LST-NG", "I-sp"];
                                            }
                                            break;
                                        
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "nice":
                                // NICE (no.1) (1, 2, 3)
                                if (this.checkInputExistAndSetFocuse("record", "nice", "d")) {
                                    option = ["1", "2", "3"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "number":
                                // number (no.1) (數字, several, multiple)
                                if (this.checkInputExistAndSetFocuse("finding", "number", "d")) {
                                    option = ["數字", "several", "multiple"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "object":
                                // object (no.1) (object)
                                if (this.checkInputExistAndSetFocuse("record", "object", "d")) {
                                    option = ["object"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "orientation":
                                // orientation (no.2) (proximal, middle, distal, upper, lower)
                                // orientation (no.1) (AW, PW, GC, LC)
                                if (this.checkInputExistAndSetFocuse("record", "orien", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([7, 8, 9, 10, 11, 12, 14, 16, 39, 40, 41, 42, 43, 45, 46, 47, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574, 559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // orientation (no.1)
                                                option = ["AW", "PW", "GC", "LC"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // orientation (no.2)
                                                option = ["proximal", "middle", "distal", "upper", "lower"];
                                            }
                                            break;
                                        case 3: // Sigmoidoscopy
                                            if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // orientation (no.2)
                                                option = ["proximal", "middle", "distal", "upper", "lower"];
                                            }
                                            break;
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "paris":
                                // Paris (no.1) (0-I, 0-IIa, 0-IIb, 0-IIc, 0-III)
                                if (this.checkInputExistAndSetFocuse("record", "paris", "d")) {
                                    option = ["0-I", "0-IIa", "0-IIb", "0-IIc", "0-III"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "prague c":
                                // Prague C (no.1) (cm)
                                if (this.checkInputExistAndSetFocuse("record", "prgC", "d")) {
                                    option = ["cm"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "prague m":
                                // Prague M (no.1) (cm)
                                if (this.checkInputExistAndSetFocuse("record", "prgM", "d")) {
                                    option = ["cm"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "red color sign":
                                // red color sign (no.1) (negative, red whale marking, cherry-red spot)
                                if (this.checkInputExistAndSetFocuse("record", "rcs", "d")) {
                                    option = ["negative", "red whale marking", "cherry-red spot"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "removed":
                                // removed (no.1) (yes, no)
                                if (this.checkInputExistAndSetFocuse("record", "removed", "d")) {
                                    option = ["yes", "no"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "r/o":
                                // r/o (no.1) (early cancer, advanced cancer)
                                // r/o (no.2) (proctitis, malignancy, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.3) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.4) (acute gastritis, hemorrhagic gastritis, chronic gastritis, superficial gastritis, atrophic gastritis, portal hypertensive gastropathy)
                                // r/o (no.5) (diverticulosis, diverticulitis, diverticular bleeding)
                                // r/o (no.6) (fundal gland polyp, adenomatous polyp, hyperplastic polyp, gastric CA, FAP)
                                // r/o (no.7) (IBD, ulcerative colitis, Crohn's disease, TB related lesion, amoeba)
                                // r/o (no.8) (lipoma, carcinoid tumor, GIST, metastatic tumor, extraluminal impression, appendiceal tumor, NET, lymphoma, hemangioma, lymphangioma)
                                // r/o (no.9) (lipoma, carcinoid tumor, GIST, metastatic tumor, extraluminal impression, NET, lymphoma, hemangioma)
                                // r/o (no.10) (upper GI, lower GI, occult bleeding, unknown bleeder)
                                // r/o (no.11) (dysplasia, cancer)
                                // r/o (no.12) (diverticulitis, diverticular bleeding)
                                // r/o (no.13) (diverticulosis, diverticular bleeding)
                                // r/o (no.14) (hemorrhagic gastritis, chronic gastritis, superficial gastritis, atrophic gastritis, portal hypertensive gastropathy)
                                // r/o (no.15) (acute gastritis, chronic gastritis, superficial gastritis, atrophic gastritis, portal hypertensive gastropathy)
                                // r/o (no.16) (acute gastritis, hemorrhagic gastritis, superficial gastritis, atrophic gastritis, portal hypertensive gastropathy)
                                // r/o (no.17) (acute gastritis, hemorrhagic gastritis, chronic gastritis, atrophic gastritis, portal hypertensive gastropathy)
                                // r/o (no.18) (acute gastritis, hemorrhagic gastritis, chronic gastritis, superficial gastritis, portal hypertensive gastropathy)
                                // r/o (no.19) (acute gastritis, hemorrhagic gastritis, chronic gastritis, superficial gastritis, atrophic gastritis)
                                // r/o (no.20) (adenomatous polyp, hyperplastic polyp, gastric CA, FAP)
                                // r/o (no.21) (fundal gland polyp, hyperplastic polyp, gastric CA, FAP)
                                // r/o (no.22) (fundal gland polyp, adenomatous polyp, gastric CA, FAP)
                                // r/o (no.23) (fundal gland polyp, adenomatous polyp, hyperplastic polyp, gastric CA)
                                // r/o (no.24) (proctitis, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.25) (proctitis, IBD, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.26) (proctitis, IBD, ulcerative colitis, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.27) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis)
                                // r/o (no.28) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, pseudomembranous colitis)
                                // r/o (no.29) (proctitis, IBD, ulcerative colitis, Crohn's disease, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.30) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.31) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.32) (proctitis, IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.33) (IBD, ulcerative colitis, Crohn's disease, infectious colitis, TB colitis, amoebic colitis, radiation colitis, ischemic colitis, pseudomembranous colitis)
                                // r/o (no.34) (diverticulosis)
                                // r/o (no.35) (occult bleeding, unknown bleeder)
                                // r/o (no.36) (upper GI, lower GI, unknown bleeder)
                                // r/o (no.37) (upper GI, lower GI, occult bleeding)
                                if (this.checkInputExistAndSetFocuse("record", "ro", "d")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.1)
                                                option = ["early cancer", "advanced cancer"];
                                            } else if ([8].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.4)
                                                option = ["acute gastritis", "hemorrhagic gastritis", "chronic gastritis", "superficial gastritis", "atrophic gastritis", "portal hypertensive gastropathy"];
                                            } else if ([9].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.6)
                                                option = ["fundal gland polyp", "adenomatous polyp", "hyperplastic polyp", "gastric CA", "FAP"];
                                            } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.9)
                                                option = ["lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "NET", "lymphoma", "hemangioma"];
                                            } else if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.11)
                                                option = ["dysplasia", "cancer"];
                                            } else if ([566].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.14)
                                                option = ["hemorrhagic gastritis", "chronic gastritis", "superficial gastritis", "atrophic gastritis", "portal hypertensive gastropathy"];
                                            } else if ([567].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.15)
                                                option = ["acute gastritis", "chronic gastritis", "superficial gastritis", "atrophic gastritis", "portal hypertensive gastropathy"];
                                            } else if ([568].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.16)
                                                option = ["acute gastritis", "hemorrhagic gastritis", "superficial gastritis", "atrophic gastritis", "portal hypertensive gastropathy"];
                                            } else if ([569].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.17)
                                                option = ["acute gastritis", "hemorrhagic gastritis", "chronic gastritis", "atrophic gastritis", "portal hypertensive gastropathy"];
                                            } else if ([570].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.18)
                                                option = ["acute gastritis", "hemorrhagic gastritis", "chronic gastritis", "superficial gastritis", "portal hypertensive gastropathy"];
                                            } else if ([571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.19)
                                                option = ["acute gastritis", "hemorrhagic gastritis", "chronic gastritis", "superficial gastritis", "atrophic gastritis"];
                                            } else if ([572].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.20)
                                                option = ["adenomatous polyp", "hyperplastic polyp", "gastric CA", "FAP"];
                                            } else if ([573].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.21)
                                                option = ["fundal gland polyp", "hyperplastic polyp", "gastric CA", "FAP"];
                                            } else if ([540].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.22)
                                                option = ["fundal gland polyp", "adenomatous polyp", "gastric CA", "FAP"];
                                            } else if ([574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.23)
                                                option = ["fundal gland polyp", "adenomatous polyp", "hyperplastic polyp", "gastric CA"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.2)
                                                option = ["proctitis", "malignancy", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([23, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.3)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([35, 36].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.5)
                                                option = ["diverticulosis", "diverticulitis", "diverticular bleeding"];
                                            } else if ([50].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.7)
                                                option = ["IBD", "ulcerative colitis", "Crohn's disease", "TB related lesion", "amoeba"];
                                            } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.8)
                                                option = ["lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "appendiceal tumor", "NET", "lymphoma", "hemangioma", "lymphangioma"];
                                            } else if ([48, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.10)
                                                option = ["upper GI", "lower GI", "occult bleeding", "unknown bleeder"];
                                            } else if ([37].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.12)
                                                option = ["diverticulitis", "diverticular bleeding"];
                                            } else if ([564].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.13)
                                                option = ["diverticulosis", "diverticular bleeding"];
                                            } else if ([24].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.24)
                                                option = ["proctitis", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([25].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.25)
                                                option = ["proctitis", "IBD", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([26].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.26)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([27].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.27)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis"];
                                            } else if ([28].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.28)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "pseudomembranous colitis"];
                                            } else if ([29].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.29)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([30].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.30)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([31].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.31)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([32].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.32)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([33].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.33)
                                                option = ["IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.34)
                                                option = ["diverticulosis"];
                                            } else if ([579, 580].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.35)
                                                option = ["occult bleeding", "unknown bleeder"];
                                            } else if ([581].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.36)
                                                option = ["upper GI", "lower GI", "unknown bleeder"];
                                            } else if ([582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.37)
                                                option = ["upper GI", "lower GI", "occult bleeding"];
                                            }
                                            break;
                                        case 3: // Colonoscopy
                                            if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.2)
                                                option = ["proctitis", "malignancy", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([23, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.3)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([35, 36].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.5)
                                                option = ["diverticulosis", "diverticulitis", "diverticular bleeding"];
                                            } else if ([50].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.7)
                                                option = ["IBD", "ulcerative colitis", "Crohn's disease", "TB related lesion", "amoeba"];
                                            } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.8)
                                                option = ["lipoma", "carcinoid tumor", "GIST", "metastatic tumor", "extraluminal impression", "appendiceal tumor", "NET", "lymphoma", "hemangioma", "lymphangioma"];
                                            } else if ([48, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.10)
                                                option = ["upper GI", "lower GI", "occult bleeding", "unknown bleeder"];
                                            } else if ([37].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.12)
                                                option = ["diverticulitis", "diverticular bleeding"];
                                            } else if ([564].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.13)
                                                option = ["diverticulosis", "diverticular bleeding"];
                                            } else if ([24].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.24)
                                                option = ["proctitis", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([25].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.25)
                                                option = ["proctitis", "IBD", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([26].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.26)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([27].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.27)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis"];
                                            } else if ([28].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.28)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "pseudomembranous colitis"];
                                            } else if ([29].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.29)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([30].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.30)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([31].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.31)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([32].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.32)
                                                option = ["proctitis", "IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([33].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.33)
                                                option = ["IBD", "ulcerative colitis", "Crohn's disease", "infectious colitis", "TB colitis", "amoebic colitis", "radiation colitis", "ischemic colitis", "pseudomembranous colitis"];
                                            } else if ([578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.34)
                                                option = ["diverticulosis"];
                                            } else if ([579, 580].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.35)
                                                option = ["occult bleeding", "unknown bleeder"];
                                            } else if ([581].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.36)
                                                option = ["upper GI", "lower GI", "unknown bleeder"];
                                            } else if ([582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // r/o (no.37)
                                                option = ["upper GI", "lower GI", "occult bleeding"];
                                            }
                                            break;
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "sign":
                                // sign (no.1) (bleeding, inflammation, bezoar)
                                if (this.checkInputExistAndSetFocuse("record", "sign", "d")) {
                                    option = ["bleeding", "inflammation", "bezoar"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "size":
                                // size (no.1) (cm)
                                if (this.checkInputExistAndSetFocuse("record", "size", "d")) {
                                    option = ["cm"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "skip-lesion":
                                // skip-lesion (no.1) (yes, no)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "des":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 233);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 233);
                                                }
                                                break;                
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "skipLesion", "d")) {
                                            option = ["yes", "no"];
                                            this.showOptionTip(option);
                                        }
                                }
                                resolve();
                                break;
                            case "sessile or pedunculated":
                                // sessile or pedunculated (no.1) (sessile, pedunculated)
                                if (this.checkInputExistAndSetFocuse("record", "sorP", "d")) {
                                    option = ["sessile", "pedunculated"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "s pattern":
                                // S pattern (no.1) (regular, irregular, absent)
                                if (this.checkInputExistAndSetFocuse("record", "sPat", "d")) {
                                    option = ["regular", "irregular", "absent"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "take notes of":
                                // take notes of (no.1) (the most significant, each, overall)
                                if (this.checkInputExistAndSetFocuse("finding", "takeNote", "d")) {
                                    option = ["the most significant", "each", "overall"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "ulcer stage":
                                // ulcer stage (no.1) (active, healing, scar, A1, A2, H1, H2, S1, S2)
                                if (this.checkInputExistAndSetFocuse("record", "ulcerStage", "d")) {
                                    option = ["active", "healing", "scar", "A1", "A2", "H1", "H2", "S1", "S2"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "v pattern":
                                // V pattern (no.1) (regular, irregular, absent)
                                if (this.checkInputExistAndSetFocuse("record", "vPat", "d")) {
                                    option = ["regular", "irregular", "absent"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "alligator":
                                // alligator (no.1) (alligator)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 253);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 253);
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "alligator", "i")) {
                                            this.writeInput("record", "c2", 148);
                                        }
                                }
                                resolve();
                                break;
                            case "apc":
                                // APC (no.1) (APC)
                                if (this.checkInputExistAndSetFocuse("record", "apc", "i")) {
                                    this.writeInput("record", "c2", 119);
                                }
                                resolve();
                                break;
                            case "biopsy forceps":
                                // biopsy forceps (no.1) (biopsy forceps)
                                if (this.checkInputExistAndSetFocuse("record", "biopFor", "i")) {
                                    this.writeInput("record", "c2", 145);
                                }
                                resolve();
                                break;
                            case "minor bleeding":
                                // minor bleeding (no.1) (minor bleeding)
                                if (this.checkInputExistAndSetFocuse("record", "bleedMinor", "i")) {
                                    this.writeInput("record", "c2", 173);
                                }
                                resolve();
                                break;
                            case "cap":
                                // cap (no.1) (cap)
                                if (this.checkInputExistAndSetFocuse("record", "cap", "i")) {
                                    this.writeInput("record", "c2", 144);
                                }
                                resolve();
                                break;
                            case "hemoclip":
                                // hemoclip (no.1) (hemoclip)
                                if (this.checkInputExistAndSetFocuse("record", "clip", "i")) {
                                    option = ["hemoclip"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "clo location":
                                // CLO location (no.1) (pylorus, antrum, low-body)
                                if (this.checkInputExistAndSetFocuse("record", "cloLoca", "i")) {
                                    option = ["pylorus", "antrum", "low-body"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "coagrasper":
                                // coagrasper (no.1) (coagrasper)
                                if (this.checkInputExistAndSetFocuse("record", "coag", "i")) {
                                    this.writeInput("record", "c2", 120);
                                }
                                resolve();
                                break;
                            case "cold_snare":
                            case "cold snare":
                                // cold snare (no.1) (cold snare)
                                if(this.colonPolypectomyFocus || this.getFindings[findingIndex].records[recordIndex].questions['interven'].value === "59"){
                                    if (this.checkInputExistAndSetFocuse("record", "coldSnare", "i")) {
                                        this.writeInput("record", "c2", 156);
                                    }
                                } else {
                                    switch (this.getStoreHiddenParameter.focus) {
                                        case "interven":
                                            switch (Number(this.examination_typeID)) {
                                                case 1: // Gastroscopy
                                                    if ([9, 572, 573, 540, 574, 11, 16, 10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "75");
                                                    }
                                                    break;
                                                case 2: // Colonoscopy
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "75");
                                                    }
                                                    break;
                                                case 3: // copy from case = '2' (Colonoscopy)
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "75");
                                                    }
                                                    break;
                                            }
                                            break;
                                        default:
                                            if (this.checkInputExistAndSetFocuse("record", "cold_snare", "m")) {
                                                this.writeInput("record", "c2", 156);
                                            }
                                            if (this.checkInputExistAndSetFocuse("record", "coldSnare", "i")) {
                                                this.writeInput("record", "c2", 156);
                                            }
                                    }
                                }
                                resolve();
                                break;
                            case "perforation":
                                // perforation (no.1) (perforation, closed)
                                if (this.getStoreHiddenParameter.focus == "perfor") {
                                    this.writeInput("record", "s", "123");
                                } else if (this.checkInputExistAndSetFocuse("record", "perfor", "i")) {
                                    option = ["perforation", "closed"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "completely removed":
                                // completely removed (no.1) (completely removed)
                                if (this.checkInputExistAndSetFocuse("record", "comremove", "i")) {
                                    this.writeInput("record", "c2", 88);
                                }
                                resolve();
                                break;
                            case "diluted epinephrine":
                                // diluted epinephrine (no.1) (diluted epinephrine)
                                if (this.checkInputExistAndSetFocuse("record", "diEpi", "i")) {
                                    this.writeInput("record", "c2", 122);
                                }
                                resolve();
                                break;
                            case "dualknife":
                                // dualknife (no.1) (dualknife)
                                if (this.checkInputExistAndSetFocuse("record", "dualK", "i")) {
                                    this.writeInput("record", "c2", 133);
                                }
                                resolve();
                                break;
                            case "elective":
                                // elective (no.1) (elective)
                                if (this.checkInputExistAndSetFocuse("record", "ele", "i")) {
                                    this.writeInput("record", "c2", 158);
                                }
                                resolve();
                                break;
                            case "en bloc":
                                // En bloc (no.1) (En bloc)
                                if (this.checkInputExistAndSetFocuse("record", "enbloc", "i")) {
                                    this.writeInput("record", "c2", 152);
                                }
                                resolve();
                                break;
                            case "endolifter":
                                // endolifter (no.1) (endolifter)
                                if (this.checkInputExistAndSetFocuse("record", "endolift", "i")) {
                                    this.writeInput("record", "c2", 143);
                                }
                                resolve();
                                break;
                            case "endoloop":
                                // endoloop (no.1) (endoloop)
                                if (this.checkInputExistAndSetFocuse("record", "endoloop", "i")) {
                                    this.writeInput("record", "c2", 151);
                                }
                                resolve();
                                break;
                            case "flexknife":
                                // flexknife (no.1) (flexknife)
                                if (this.checkInputExistAndSetFocuse("record", "flexK", "i")) {
                                    this.writeInput("record", "c2", 139);
                                }
                                resolve();
                                break;
                            case "glycerol":
                                // glycerol (no.1) (glycerol)
                                if (this.checkInputExistAndSetFocuse("record", "glyce", "i")) {
                                    this.writeInput("record", "c2", 128);
                                }
                                resolve();
                                break;
                            case "grasping forceps":
                                // grasping forceps (no.1) (grasping forceps)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 252);
                                                }
                                                break;
                                            case 3: // Sigmoidoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 252);
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "graFor", "i")) {
                                            this.writeInput("record", "c2", 146);
                                        }
                                }
                                resolve();
                                break;
                            case "histoacryl":
                                // histoacryl (no.1) (histoacryl)
                                if (this.checkInputExistAndSetFocuse("record", "histo", "i")) {
                                    this.writeInput("record", "c2", 160);
                                }
                                resolve();
                                break;
                            case "hookknife":
                                // hookknife (no.1) (hookknife)
                                if (this.checkInputExistAndSetFocuse("record", "hookK", "i")) {
                                    this.writeInput("record", "c2", 138);
                                }
                                resolve();
                                break;
                            case "heater probe":
                                // heater probe (no.1) (heater probe)
                                if (this.checkInputExistAndSetFocuse("record", "hProbe", "i")) {
                                    this.writeInput("record", "c2", 121);
                                }
                                resolve();
                                break;
                            case "hyaluronic acid":
                                // hyaluronic acid (no.1) (hyaluronic acid)
                                if (this.checkInputExistAndSetFocuse("record", "hyAcid", "i")) {
                                    this.writeInput("record", "c2", 129);
                                }
                                resolve();
                                break;
                            case "hybrid knife":
                                // hybrid knife (no.1) (hybrid knife)
                                if (this.checkInputExistAndSetFocuse("record", "hybridK", "i")) {
                                    this.writeInput("record", "c2", 141);
                                }
                                resolve();
                                break;
                            case "indigo carmine":
                                // indigo carmine (no.1) (indigo carmine)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "chroMag":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 188);
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "indigo", "i")) {
                                            this.writeInput("record", "c2", 131);
                                        }
                                }
                                resolve();
                                break;
                            case "intervention":
                                // intervention (no.1) (biopsy, ARMS, Stretta, hot biopsy, cold biopsy, other)
                                // intervention (no.2) (biopsy, CLO, hemostasis, hot biopsy, cold biopsy, other)
                                // intervention (no.3) (biopsy, polypectomy, EMR, ESD, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p endolooping, other)
                                // intervention (no.4) (biopsy, hot biopsy, cold biopsy, other)
                                // intervention (no.5) (biopsy, hemostasis, hot biopsy, cold biopsy, other)
                                // intervention (no.6) (biopsy, EMR, ESD, RFA, hot biopsy, cold biopsy, s/p endolooping, s/p stenting, other)
                                // intervention (no.7) (biopsy, CLO, hot biopsy, cold biopsy, other)
                                // intervention (no.8) (biopsy, polypectomy, EMR, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p endolooping, other)
                                // intervention (no.9) (biopsy, CLO, hemostasis, polypectomy, EMR, ESD, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p endolooping, s/p tattooing, s/p stenting, other)
                                // intervention (no.10) (hemostasis, bezoar removal, other)
                                // intervention (no.11) (hemostasis, other)
                                // intervention (no.12) (biopsy, ESD, RFA, hot biopsy, cold biopsy, other)
                                // intervention (no.13) (biopsy, polypectomy, EMR, ESD, STER, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p tattooing, other)
                                // intervention (no.14) (EVL, EIS, SB tube, other)
                                // intervention (no.15) (GVL, GIS, other)
                                // intervention (no.16) (band ligation, sclerotherapy, infrared coagulation, other)
                                // intervention (no.17) (biopsy, polypectomy, EMR, ESD, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p endolooping, s/p tattooing, s/p stenting, other)
                                // intervention (no.18) (biopsy, polypectomy, EMR, ESD, hot biopsy, cold biopsy, snare, cold snare, hot snare, s/p tattooing, s/p stenting, other)
                                // intervention (no.19) (hemostasis, s/p tattooing, s/p stenting, other)
                                // intervention (no.20) (biopsy, hemostasis, hot biopsy, cold biopsy, s/p stenting, other)
                                // intervention (no.21) (other)
                                // intervention (no.22) (s/p stenting, other)
                                if (this.checkInputExistAndSetFocuse("record", "interven", "i")) {
                                    switch (Number(this.examination_typeID)) {
                                        case 1: // Gastroscopy
                                            if ([1, 565].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.1)
                                                option = ["biopsy", "ARMS", "Stretta", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.2)
                                                option = ["biopsy", "CLO", "hemostasis", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([14].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.4)
                                                option = ["biopsy", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.6)
                                                option = ["biopsy", "EMR", "ESD", "RFA", "hot biopsy", "cold biopsy", "s/p endolooping", "s/p stenting", "other"];
                                            } else if ([8, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.7)
                                                option = ["biopsy", "CLO", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([9, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.8)
                                                option = ["biopsy", "polypectomy", "EMR", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "other"];
                                            } else if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.9)
                                                option = ["biopsy", "CLO", "hemostasis", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.12)
                                                option = ["biopsy", "ESD", "RFA", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.13)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "STER", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p tattooing", "other"];
                                            } else if ([5].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.14)
                                                option = ["EVL", "EIS", "SB tube", "other"];
                                            } else if ([6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.15)
                                                option = ["GVL", "GIS", "other"];
                                            } else if ([3, 13, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.21)
                                                option = ["other"];
                                            } else if ([559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.22)
                                                option = ["s/p stenting", "other"];
                                            }
                                            break;
                                        case 2: // Colonoscopy
                                            if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.3)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "other"];
                                            } else if ([38, 50, 52, 558].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.4)
                                                option = ["biopsy", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.5)
                                                option = ["biopsy", "hemostasis", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.10)
                                                option = ["hemostasis", "bezoar removal", "other"];
                                            } else if ([561].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.11)
                                                option = ["hemostasis", "other"];
                                            } else if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.16)
                                                option = ["band ligation", "sclerotherapy", "infrared coagulation", "other"];
                                            } else if ([57, 543, 544, 545, 546, 547, 549, 550].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.17)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.18)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([48, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.19)
                                                option = ["hemostasis", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 560].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.20)
                                                option = ["biopsy", "hemostasis", "hot biopsy", "cold biopsy", "s/p stenting", "other"];
                                            } else if ([49, 51, 554, 556, 557, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.21)
                                                option = ["other"];
                                            } else if ([555, 559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.22)
                                                option = ["s/p stenting", "other"];
                                            }
                                            break;
                                        case 3: // Colonoscopy
                                            if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.3)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "other"];
                                            } else if ([38, 50, 52, 558].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.4)
                                                option = ["biopsy", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.5)
                                                option = ["biopsy", "hemostasis", "hot biopsy", "cold biopsy", "other"];
                                            } else if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.10)
                                                option = ["hemostasis", "bezoar removal", "other"];
                                            } else if ([561].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.11)
                                                option = ["hemostasis", "other"];
                                            } else if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.16)
                                                option = ["band ligation", "sclerotherapy", "infrared coagulation", "other"];
                                            } else if ([57, 543, 544, 545, 546, 547, 549, 550].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.17)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p endolooping", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.18)
                                                option = ["biopsy", "polypectomy", "EMR", "ESD", "hot biopsy", "cold biopsy", "snare", "cold snare", "hot snare", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([48, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.19)
                                                option = ["hemostasis", "s/p tattooing", "s/p stenting", "other"];
                                            } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 560].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.20)
                                                option = ["biopsy", "hemostasis", "hot biopsy", "cold biopsy", "s/p stenting", "other"];
                                            } else if ([49, 51, 554, 556, 557, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.21)
                                                option = ["other"];
                                            } else if ([555, 559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) { // intervention (no.22)
                                                option = ["s/p stenting", "other"];
                                            }
                                            break;
                                    }
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "itknife":
                                // ITKnife (no.1) (ITKnife)
                                if (this.checkInputExistAndSetFocuse("record", "itK", "i")) {
                                    this.writeInput("record", "c2", 134);
                                }
                                resolve();
                                break;
                            case "itknife-2":
                                // ITKnife-2 (no.1) (ITKnife-2)
                                if (this.checkInputExistAndSetFocuse("record", "itK2", "i")) {
                                    this.writeInput("record", "c2", 135);
                                }
                                resolve();
                                break;
                            case "itknife nano":
                                // ITKnife nano (no.1) (ITKnife nano)
                                if (this.checkInputExistAndSetFocuse("record", "itKnano", "i")) {
                                    this.writeInput("record", "c2", 136);
                                }
                                resolve();
                                break;
                            case "specimen label":
                                // specimen label (no.1) (specimen label)
                                if (this.checkInputExistAndSetFocuse("record", "label", "i")) {
                                    option = ["specimen label"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "lipiodol":
                                // lipiodol (no.1) (lipiodol)
                                if (this.checkInputExistAndSetFocuse("record", "lipi", "i")) {
                                    this.writeInput("record", "c2", 161);
                                }
                                resolve();
                                break;
                            case "needle knife":
                                // needle knife (no.1) (needle knife)
                                if (this.checkInputExistAndSetFocuse("record", "neeK", "i")) {
                                    this.writeInput("record", "c2", 140);
                                }
                                resolve();
                                break;
                            case "net":
                                // net (no.1) (net)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "finding":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                this.writeInput("finding", "s", "45");
                                                break;
                                            case 2: // Colonoscopy
                                                this.writeInput("finding", "s", "45");
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                this.writeInput("finding", "s", "45");
                                                break;
                                        }
                                        break;
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 254);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 254);
                                                }
                                                break;
                                        }
                                        break;
                                    case "ro":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 475);
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 475);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 475);
                                                }
                                                break;                                           
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "net", "i")) {
                                            this.writeInput("record", "c2", 147);
                                        }
                                }
                                resolve();
                                break;
                            case "pentapod grasping forceps":
                                // pentapod grasping forceps (no.1) (pentapod grasping forceps)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 251);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 251);
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "pentaFor", "i")) {
                                            this.writeInput("record", "c2", 150);
                                        }
                                }
                                resolve();
                                break;
                            case "removal forceps":
                                // removal forceps (no.1) (removal forceps)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 250);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "c", 250);
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "reFor", "i")) {
                                            this.writeInput("record", "c2", 149);
                                        }
                                }
                                resolve();
                                break;
                            case "rubber band":
                                // rubber band (no.1) (rubber band)
                                if (this.checkInputExistAndSetFocuse("record", "rubband", "i")) {
                                    option = ["rubber band"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "saline":
                                // saline (no.1) (saline)
                                if (this.checkInputExistAndSetFocuse("record", "saline", "i")) {
                                    this.writeInput("record", "c2", 130);
                                }
                                resolve();
                                break;
                            case "sb tube":
                                // SB tube (no.1) (SB tube)
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "interven":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "s", "521");
                                                }
                                                break;
                                        }
                                        break;
                                    default:
                                        if (this.checkInputExistAndSetFocuse("record", "sbtue", "i")) {
                                            this.writeInput("record", "c2", 172);
                                        }
                                }
                                resolve();
                                break;
                            case "snare":
                                // snare (no.1) (snare)
                                if(this.colonPolypectomyFocus || this.getFindings[findingIndex].records[recordIndex].questions['interven'].value === "59"){
                                    if (this.checkInputExistAndSetFocuse("record", "snare", "i")) {
                                        this.writeInput("record", "c2", 142);
                                    }
                                }else{
                                    switch (this.getStoreHiddenParameter.focus) {
                                        case "interven":
                                            switch (Number(this.examination_typeID)) {
                                                case 1: // Gastroscopy
                                                    if ([9, 572, 573, 540, 574, 11, 16, 10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "74");
                                                    }
                                                    break;
                                                case 2: // Colonoscopy
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "74");
                                                    }
                                                    break;
                                                case 3: // copy from case = '2' (Colonoscopy)
                                                    if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548, 57, 543, 544, 545, 546, 547, 549, 550, 17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "s", "74");
                                                    }
                                                    break;
                                            }
                                            break;
                                        case "dev":
                                            switch (Number(this.examination_typeID)) {
                                                case 2: // Colonoscopy
                                                    if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "c", 255);
                                                    }
                                                    break;
                                                case 3: // copy from case = '2' (Colonoscopy)
                                                    if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                        this.writeInput("record", "c", 255);
                                                    }
                                                    break;
                                            }
                                            break;
                                        default:
                                            if (this.checkInputExistAndSetFocuse("record", "snare", "i")) {
                                                this.writeInput("record", "c2", 142);
                                            }
                                    }
                                }
                                resolve();
                                break;
                            case "sucralfate gel":
                                // sucralfate gel (no.1) (sucralfate gel)
                                if (this.checkInputExistAndSetFocuse("record", "sucra", "i")) {
                                    this.writeInput("record", "c2", 132);
                                }
                                resolve();
                                break;
                            case "pieces of tissue":
                                // pieces of tissue (no.1) (pieces of tissue)
                                if (this.checkInputExistAndSetFocuse("record", "tissue", "i")) {
                                    option = ["pieces of tissue"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "tooth":
                                // tooth (no.1) (tooth)
                                if (this.checkInputExistAndSetFocuse("record", "tooth", "i")) {
                                    this.writeInput("record", "c2", 174);
                                }
                                resolve();
                                break;
                            case "triangle knife":
                                // triangle knife (no.1) (triangle knife)
                                if (this.checkInputExistAndSetFocuse("record", "triK", "i")) {
                                    this.writeInput("record", "c2", 137);
                                }
                                resolve();
                                break;
                            case "major bleeding":
                                // major bleeding (no.1) (major bleeding)
                                if (this.checkInputExistAndSetFocuse("record", "bleedMajor", "i")) {
                                    this.writeInput("record", "c2", 68);
                                }
                                resolve();
                                break;
                            case "intervention others":
                                // intervention others (no.1) (intervention others)
                                if (this.checkInputExistAndSetFocuse("record", "intervenOther", "i")) {
                                    option = ["intervention others"];
                                    this.showOptionTip(option);
                                }
                                resolve();
                                break;
                            case "bleeding stop":
                                // bleeding stop (no.1) (bleeding stop)
                                if (this.checkInputExistAndSetFocuse("record", "bleedStop", "i")) {
                                    this.writeInput("record", "c2", 69);
                                }
                                resolve();
                                break;
                            case "bleeding continue":
                                // bleeding continue (no.1) (bleeding continue)
                                if (this.checkInputExistAndSetFocuse("record", "bleedContinue", "i")) {
                                    this.writeInput("record", "c2", 70);
                                }
                                resolve();
                                break;
                            default:
                                //==========================================================================
                                //※ 第三層 填寫欄位
                                //==========================================================================                        
                                switch (this.getStoreHiddenParameter.focus) {
                                    case "actBle":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "175");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "176");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "bleTen":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 179);
                                                            break;
                                                        case "nipple sign":
                                                            this.writeInput("record", "c", 180);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 177);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 178);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 179);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 177);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 178);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 179);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "borr":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "1":
                                                            this.writeInput("record", "s", "181");
                                                            break;
                                                        case "2":
                                                            this.writeInput("record", "s", "182");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "183");
                                                            break;
                                                        case "4":
                                                            this.writeInput("record", "s", "184");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "chroMag":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "nbi":
                                                            this.writeInput("record", "c", 185);
                                                            break;
                                                        case "bli":
                                                            this.writeInput("record", "c", 186);
                                                            break;
                                                        case "lugol's solution":
                                                            this.writeInput("record", "c", 187);
                                                            break;
                                                        case "indigo carmine":
                                                            this.writeInput("record", "c", 188);
                                                            break;
                                                        case "magnification":
                                                            this.writeInput("record", "c", 531);
                                                            break;
                                                        case "acetic acid":
                                                            this.writeInput("record", "c", 72);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "chroSign":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "silver sign":
                                                            this.writeInput("record", "c", 189);
                                                            break;
                                                        case "pink-color sign":
                                                            this.writeInput("record", "c", 190);
                                                            break;
                                                        case "brownish color":
                                                            this.writeInput("record", "c", 191);
                                                            break;
                                                        case "light color":
                                                            this.writeInput("record", "c", 192);
                                                            break;
                                                        case "lugol-voiding":
                                                            this.writeInput("record", "c", 193);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "color":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "white":
                                                            this.writeInput("record", "s", "194");
                                                            break;
                                                        case "blue":
                                                            this.writeInput("record", "s", "195");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "conSur":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6, 1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "196");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "197");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "196");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "197");
                                                            break;
                                                    }
                                                } else if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "196");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "197");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "196");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "197");
                                                            break;
                                                    }
                                                } else if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "196");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "197");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "demarc":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "present":
                                                            this.writeInput("record", "s", "198");
                                                            break;
                                                        case "absent":
                                                            this.writeInput("record", "s", "199");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "des":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([8, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "edema":
                                                            this.writeInput("record", "c", 201);
                                                            break;
                                                        case "erythema":
                                                            this.writeInput("record", "c", 202);
                                                            break;
                                                        case "friability":
                                                            this.writeInput("record", "c", 203);
                                                            break;
                                                        case "exudate":
                                                            this.writeInput("record", "c", 204);
                                                            break;
                                                        case "flat erosion":
                                                            this.writeInput("record", "c", 205);
                                                            break;
                                                        case "raised erosion":
                                                            this.writeInput("record", "c", 206);
                                                            break;
                                                        case "nodularity":
                                                            this.writeInput("record", "c", 207);
                                                            break;
                                                        case "rugal hypertrophy":
                                                            this.writeInput("record", "c", 208);
                                                            break;
                                                        case "gastric fold hypertrophy":
                                                            this.writeInput("record", "c", 209);
                                                            break;
                                                        case "rugal atrophy":
                                                            this.writeInput("record", "c", 210);
                                                            break;
                                                        case "gastric mucosa atrophy":
                                                            this.writeInput("record", "c", 211);
                                                            break;
                                                        case "visibility of vascular pattern":
                                                            this.writeInput("record", "c", 212);
                                                            break;
                                                        case "intramural bleeding spots":
                                                            this.writeInput("record", "c", 213);
                                                            break;
                                                        case "intestinal metaplasia":
                                                            this.writeInput("record", "c", 214);
                                                            break;
                                                        case "diffuse redness":
                                                            this.writeInput("record", "c", 215);
                                                            break;
                                                        case "erosions":
                                                            this.writeInput("record", "c", 216);
                                                            break;
                                                    }
                                                } else if ([10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elastic":
                                                            this.writeInput("record", "c", 217);
                                                            break;
                                                        case "soft":
                                                            this.writeInput("record", "c", 218);
                                                            break;
                                                        case "hard":
                                                            this.writeInput("record", "c", 219);
                                                            break;
                                                        case "pillow sign":
                                                            this.writeInput("record", "c", 220);
                                                            break;
                                                        case "yellow":
                                                            this.writeInput("record", "c", 221);
                                                            break;
                                                        case "ulcerative":
                                                            this.writeInput("record", "c", 222);
                                                            break;
                                                    }
                                                } else if ([13, 559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elastic":
                                                            this.writeInput("record", "c", 217);
                                                            break;
                                                        case "soft":
                                                            this.writeInput("record", "c", 218);
                                                            break;
                                                        case "hard":
                                                            this.writeInput("record", "c", 219);
                                                            break;
                                                        case "pillow sign":
                                                            this.writeInput("record", "c", 220);
                                                            break;
                                                        case "yellow":
                                                            this.writeInput("record", "c", 221);
                                                            break;
                                                        case "ulcerative":
                                                            this.writeInput("record", "c", 222);
                                                            break;
                                                    }
                                                } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tiny":
                                                            this.writeInput("record", "c", 223);
                                                            break;
                                                        case "small":
                                                            this.writeInput("record", "c", 224);
                                                            break;
                                                        case "giant":
                                                            this.writeInput("record", "c", 225);
                                                            break;
                                                        case "shallow":
                                                            this.writeInput("record", "c", 226);
                                                            break;
                                                        case "broad":
                                                            this.writeInput("record", "c", 227);
                                                            break;
                                                        case "spotted":
                                                            this.writeInput("record", "c", 228);
                                                            break;
                                                        case "scattered":
                                                            this.writeInput("record", "c", 229);
                                                            break;
                                                        case "confluent":
                                                            this.writeInput("record", "c", 230);
                                                            break;
                                                        case "focal":
                                                            this.writeInput("record", "c", 231);
                                                            break;
                                                        case "continuous-lesion":
                                                            this.writeInput("record", "c", 232);
                                                            break;
                                                        case "skip-lesion":
                                                            this.writeInput("record", "c", 233);
                                                            break;
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 246);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 234);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                        case "mucus plaque":
                                                            this.writeInput("record", "c", 236);
                                                            break;
                                                        case "swelling mucosa":
                                                            this.writeInput("record", "c", 237);
                                                            break;
                                                        case "partial obstruction":
                                                            this.writeInput("record", "c", 238);
                                                            break;
                                                        case "nearly complete obstruction":
                                                            this.writeInput("record", "c", 239);
                                                            break;
                                                        case "complete obstruction":
                                                            this.writeInput("record", "c", 240);
                                                            break;
                                                        case "ischemia":
                                                            this.writeInput("record", "c", 241);
                                                            break;
                                                        case "necrosis":
                                                            this.writeInput("record", "c", 242);
                                                            break;
                                                        case "friability":
                                                            this.writeInput("record", "c", 203);
                                                            break;
                                                        case "erythema":
                                                            this.writeInput("record", "c", 202);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 243);
                                                            break;
                                                        case "exudate":
                                                            this.writeInput("record", "c", 204);
                                                            break;
                                                        case "overlying membrane":
                                                            this.writeInput("record", "c", 244);
                                                            break;
                                                        case "abscess":
                                                            this.writeInput("record", "c", 245);
                                                            break;
                                                    }
                                                } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 246);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 234);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                        case "mucus plaque":
                                                            this.writeInput("record", "c", 236);
                                                            break;
                                                        case "swelling mucosa":
                                                            this.writeInput("record", "c", 237);
                                                            break;
                                                        case "partial obstruction":
                                                            this.writeInput("record", "c", 238);
                                                            break;
                                                        case "nearly complete obstruction":
                                                            this.writeInput("record", "c", 239);
                                                            break;
                                                        case "complete obstruction":
                                                            this.writeInput("record", "c", 240);
                                                            break;
                                                        case "ischemia":
                                                            this.writeInput("record", "c", 241);
                                                            break;
                                                        case "necrosis":
                                                            this.writeInput("record", "c", 242);
                                                            break;
                                                        case "friability":
                                                            this.writeInput("record", "c", 203);
                                                            break;
                                                        case "erythema":
                                                            this.writeInput("record", "c", 202);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 243);
                                                            break;
                                                        case "exudate":
                                                            this.writeInput("record", "c", 204);
                                                            break;
                                                        case "overlying membrane":
                                                            this.writeInput("record", "c", 244);
                                                            break;
                                                        case "abscess":
                                                            this.writeInput("record", "c", 245);
                                                            break;
                                                    }
                                                } else if ([48, 579, 580, 581, 582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([554, 555, 556, 557, 558, 559, 560, 561, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                } else if ([583].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([584].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elastic":
                                                            this.writeInput("record", "c", 217);
                                                            break;
                                                        case "soft":
                                                            this.writeInput("record", "c", 218);
                                                            break;
                                                        case "hard":
                                                            this.writeInput("record", "c", 219);
                                                            break;
                                                        case "pillow sign":
                                                            this.writeInput("record", "c", 220);
                                                            break;
                                                        case "yellow":
                                                            this.writeInput("record", "c", 221);
                                                            break;
                                                        case "ulcerative":
                                                            this.writeInput("record", "c", 222);
                                                            break;
                                                    }
                                                } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tiny":
                                                            this.writeInput("record", "c", 223);
                                                            break;
                                                        case "small":
                                                            this.writeInput("record", "c", 224);
                                                            break;
                                                        case "giant":
                                                            this.writeInput("record", "c", 225);
                                                            break;
                                                        case "shallow":
                                                            this.writeInput("record", "c", 226);
                                                            break;
                                                        case "broad":
                                                            this.writeInput("record", "c", 227);
                                                            break;
                                                        case "spotted":
                                                            this.writeInput("record", "c", 228);
                                                            break;
                                                        case "scattered":
                                                            this.writeInput("record", "c", 229);
                                                            break;
                                                        case "confluent":
                                                            this.writeInput("record", "c", 230);
                                                            break;
                                                        case "focal":
                                                            this.writeInput("record", "c", 231);
                                                            break;
                                                        case "continuous-lesion":
                                                            this.writeInput("record", "c", 232);
                                                            break;
                                                        case "skip-lesion":
                                                            this.writeInput("record", "c", 233);
                                                            break;
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 246);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 234);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                        case "mucus plaque":
                                                            this.writeInput("record", "c", 236);
                                                            break;
                                                        case "swelling mucosa":
                                                            this.writeInput("record", "c", 237);
                                                            break;
                                                        case "partial obstruction":
                                                            this.writeInput("record", "c", 238);
                                                            break;
                                                        case "nearly complete obstruction":
                                                            this.writeInput("record", "c", 239);
                                                            break;
                                                        case "complete obstruction":
                                                            this.writeInput("record", "c", 240);
                                                            break;
                                                        case "ischemia":
                                                            this.writeInput("record", "c", 241);
                                                            break;
                                                        case "necrosis":
                                                            this.writeInput("record", "c", 242);
                                                            break;
                                                        case "friability":
                                                            this.writeInput("record", "c", 203);
                                                            break;
                                                        case "erythema":
                                                            this.writeInput("record", "c", 202);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 243);
                                                            break;
                                                        case "exudate":
                                                            this.writeInput("record", "c", 204);
                                                            break;
                                                        case "overlying membrane":
                                                            this.writeInput("record", "c", 244);
                                                            break;
                                                        case "abscess":
                                                            this.writeInput("record", "c", 245);
                                                            break;
                                                    }
                                                } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "recent bleeding":
                                                            this.writeInput("record", "c", 246);
                                                            break;
                                                        case "blood oozing":
                                                            this.writeInput("record", "c", 234);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                        case "mucus plaque":
                                                            this.writeInput("record", "c", 236);
                                                            break;
                                                        case "swelling mucosa":
                                                            this.writeInput("record", "c", 237);
                                                            break;
                                                        case "partial obstruction":
                                                            this.writeInput("record", "c", 238);
                                                            break;
                                                        case "nearly complete obstruction":
                                                            this.writeInput("record", "c", 239);
                                                            break;
                                                        case "complete obstruction":
                                                            this.writeInput("record", "c", 240);
                                                            break;
                                                        case "ischemia":
                                                            this.writeInput("record", "c", 241);
                                                            break;
                                                        case "necrosis":
                                                            this.writeInput("record", "c", 242);
                                                            break;
                                                        case "friability":
                                                            this.writeInput("record", "c", 203);
                                                            break;
                                                        case "erythema":
                                                            this.writeInput("record", "c", 202);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 243);
                                                            break;
                                                        case "exudate":
                                                            this.writeInput("record", "c", 204);
                                                            break;
                                                        case "overlying membrane":
                                                            this.writeInput("record", "c", 244);
                                                            break;
                                                        case "abscess":
                                                            this.writeInput("record", "c", 245);
                                                            break;
                                                    }
                                                } else if ([48, 579, 580, 581, 582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([554, 555, 556, 557, 558, 559, 560, 561, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                } else if ([583].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([584].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([585].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "active bleeding":
                                                            this.writeInput("record", "c", 235);
                                                            break;
                                                    }
                                                } else if ([586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hematin":
                                                            this.writeInput("record", "c", 247);
                                                            break;
                                                        case "tarry stool":
                                                            this.writeInput("record", "c", 248);
                                                            break;
                                                        case "fresh blood":
                                                            this.writeInput("record", "c", 249);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "dev":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "removal forceps":
                                                            this.writeInput("record", "c", 250);
                                                            break;
                                                        case "pentapod grasping forceps":
                                                            this.writeInput("record", "c", 251);
                                                            break;
                                                        case "grasping forceps":
                                                            this.writeInput("record", "c", 252);
                                                            break;
                                                        case "alligator":
                                                            this.writeInput("record", "c", 253);
                                                            break;
                                                        case "net":
                                                            this.writeInput("record", "c", 254);
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "c", 255);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "removal forceps":
                                                            this.writeInput("record", "c", 250);
                                                            break;
                                                        case "pentapod grasping forceps":
                                                            this.writeInput("record", "c", 251);
                                                            break;
                                                        case "grasping forceps":
                                                            this.writeInput("record", "c", 252);
                                                            break;
                                                        case "alligator":
                                                            this.writeInput("record", "c", 253);
                                                            break;
                                                        case "net":
                                                            this.writeInput("record", "c", 254);
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "c", 255);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "dist":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15, 5].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "earlyAdv":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 11, 15, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "early":
                                                            this.writeInput("record", "s", "256");
                                                            break;
                                                        case "advanced":
                                                            this.writeInput("record", "s", "257");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "finding":
                                        let checkInt = /^[0-9]*[1-9][0-9]*$/                                     
                                        if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {   
                                            // specific finding which is exisit                                                         
                                            if (this.getExaminationData.findings[(Number(voiceInput) - 1)]) {
                                                
                                                // 設定 nowFindingIndex
                                                this.setHiddenParameter((Number(voiceInput) - 1), 0);
                                                this.setStoreHiddenParameter({
                                                    target: 'nowLocationsIndex',
                                                    value: 0
                                                });
                                                this.setStoreHiddenParameter({
                                                    target: 'focus',
                                                    value: ''
                                                });
                                                this.setStoreHiddenParameter({
                                                    target: 'over',
                                                    value: false
                                                });
                                            }
                                        } else {
                                            // new finding
                                            let uiNumber                                       
                                            switch(this.examination_typeID) {
                                                case 1:
                                                    uiNumber = MapUIforFinding["Gastroscopy"][voiceInput]
                                                    break
                                                case 2:
                                                    uiNumber = MapUIforFinding["Colonoscopy"][voiceInput]
                                                    break
                                                case 3:
                                                    uiNumber = MapUIforFinding["Sigmoidoscopy"][voiceInput]
                                                    break
                                            }
                                            
                                            if (uiNumber) {   
                                                this.$store.dispatch('examinations/addFinding', this.getExaminationData.examination.id).then(() => {
                                                    if(voiceInput){
                                                        let voiceInputResult = voiceInput;
                                                        console.log("123 = " + voiceInputResult)
                                                        this.musicPlay(`${voiceInputResult}`)
                                                        setTimeout(() => { this.musicPlay('success'); }, 300);                            
                                                    }                                                          

                                                    // 設定 nowFindingIndex
                                                    const nowFindingIndex = this.getExaminationData.findings.length - 1
                                                    this.setHiddenParameter(nowFindingIndex, 0);
                                                    this.setStoreHiddenParameter({
                                                        target: 'over',
                                                        value: false
                                                    });
                                                    if (this.checkInputExistAndSetFocuse("finding", "finding", "f")) {
                                                        this.writeInput("finding", "s", uiNumber);
                                                    }
                                                    setTimeout(function() {
                                                        resolve();
                                                    }, 100);
                                                });
                                                
                                            } 
                                            else {
                                                this.musicPlay(`no finding`)
                                            }
                                        }

                                        resolve(); // here(7)
                                        break;
                                    case "form":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "f1":
                                                            this.writeInput("record", "s", "258");
                                                            break;
                                                        case "f2":
                                                            this.writeInput("record", "s", "259");
                                                            break;
                                                        case "f3":
                                                            this.writeInput("record", "s", "260");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "forrest":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ia":
                                                            this.writeInput("record", "s", "261");
                                                            break;
                                                        case "ib":
                                                            this.writeInput("record", "s", "262");
                                                            break;
                                                        case "iia":
                                                            this.writeInput("record", "s", "263");
                                                            break;
                                                        case "iib":
                                                            this.writeInput("record", "s", "264");
                                                            break;
                                                        case "iic":
                                                            this.writeInput("record", "s", "265");
                                                            break;
                                                        case "iii":
                                                            this.writeInput("record", "s", "266");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "grade":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "i":
                                                            this.writeInput("record", "s", "267");
                                                            break;
                                                        case "ii":
                                                            this.writeInput("record", "s", "268");
                                                            break;
                                                        case "iii":
                                                            this.writeInput("record", "s", "269");
                                                            break;
                                                        case "iv":
                                                            this.writeInput("record", "s", "270");
                                                            break;
                                                    }
                                                
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "i":
                                                            this.writeInput("record", "s", "267");
                                                            break;
                                                        case "ii":
                                                            this.writeInput("record", "s", "268");
                                                            break;
                                                        case "iii":
                                                            this.writeInput("record", "s", "269");
                                                            break;
                                                        case "iv":
                                                            this.writeInput("record", "s", "270");
                                                            break;
                                                    }
                                                
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hill":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([3].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "i":
                                                            this.writeInput("record", "s", "271");
                                                            break;
                                                        case "ii":
                                                            this.writeInput("record", "s", "272");
                                                            break;
                                                        case "iii":
                                                            this.writeInput("record", "s", "273");
                                                            break;
                                                        case "iv":
                                                            this.writeInput("record", "s", "274");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "invaDep":
                                        switch (Number(this.examination_typeID)) {}
                                        resolve(); // here(7)
                                        break;
                                    case "jes":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "a":
                                                            this.writeInput("record", "s", "278");
                                                            break;
                                                        case "b1":
                                                            this.writeInput("record", "s", "279");
                                                            break;
                                                        case "b2":
                                                            this.writeInput("record", "s", "280");
                                                            break;
                                                        case "b3":
                                                            this.writeInput("record", "s", "281");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "jnet":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "1":
                                                            this.writeInput("record", "s", "282");
                                                            break;
                                                        case "2a":
                                                            this.writeInput("record", "s", "283");
                                                            break;
                                                        case "2b":
                                                            this.writeInput("record", "s", "284");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "285");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "1":
                                                            this.writeInput("record", "s", "282");
                                                            break;
                                                        case "2a":
                                                            this.writeInput("record", "s", "283");
                                                            break;
                                                        case "2b":
                                                            this.writeInput("record", "s", "284");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "285");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "kudo":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "i":
                                                            this.writeInput("record", "s", "286");
                                                            break;
                                                        case "ii":
                                                            this.writeInput("record", "s", "287");
                                                            break;
                                                        case "iiis":
                                                            this.writeInput("record", "s", "288");
                                                            break;
                                                        case "iiil":
                                                            this.writeInput("record", "s", "289");
                                                            break;
                                                        case "iv":
                                                            this.writeInput("record", "s", "290");
                                                            break;
                                                        case "v":
                                                            this.writeInput("record", "s", "291");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "i":
                                                            this.writeInput("record", "s", "286");
                                                            break;
                                                        case "ii":
                                                            this.writeInput("record", "s", "287");
                                                            break;
                                                        case "iiis":
                                                            this.writeInput("record", "s", "288");
                                                            break;
                                                        case "iiil":
                                                            this.writeInput("record", "s", "289");
                                                            break;
                                                        case "iv":
                                                            this.writeInput("record", "s", "290");
                                                            break;
                                                        case "v":
                                                            this.writeInput("record", "s", "291");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "laGrade":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 565].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "a":
                                                            this.writeInput("record", "s", "292");
                                                            break;
                                                        case "b":
                                                            this.writeInput("record", "s", "293");
                                                            break;
                                                        case "c":
                                                            this.writeInput("record", "s", "294");
                                                            break;
                                                        case "d":
                                                            this.writeInput("record", "s", "295");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "loca":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 5, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cervical":
                                                            this.writeInput("record", "s", "296");
                                                            break;
                                                        case "upper":
                                                            this.writeInput("record", "s", "297");
                                                            break;
                                                        case "middle":
                                                            this.writeInput("record", "s", "298");
                                                            break;
                                                        case "lower":
                                                            this.writeInput("record", "s", "299");
                                                            break;
                                                        case "ecj":
                                                            this.writeInput("record", "s", "300");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([7, 8, 11, 16, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "antrum":
                                                            this.writeInput("record", "s", "301");
                                                            break;
                                                        case "low-body":
                                                            this.writeInput("record", "s", "302");
                                                            break;
                                                        case "mid-body":
                                                            this.writeInput("record", "s", "303");
                                                            break;
                                                        case "high-body":
                                                            this.writeInput("record", "s", "304");
                                                            break;
                                                        case "angle":
                                                            this.writeInput("record", "s", "305");
                                                            break;
                                                        case "cardia":
                                                            this.writeInput("record", "s", "306");
                                                            break;
                                                        case "fundus":
                                                            this.writeInput("record", "s", "307");
                                                            break;
                                                        case "body":
                                                            this.writeInput("record", "s", "590");
                                                            break;
                                                        case "upper-body":
                                                            this.writeInput("record", "s", "591");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([9, 10, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "antrum":
                                                            this.writeInput("record", "s", "301");
                                                            break;
                                                        case "low-body":
                                                            this.writeInput("record", "s", "302");
                                                            break;
                                                        case "mid-body":
                                                            this.writeInput("record", "s", "303");
                                                            break;
                                                        case "high-body":
                                                            this.writeInput("record", "s", "304");
                                                            break;
                                                        case "angle":
                                                            this.writeInput("record", "s", "305");
                                                            break;
                                                        case "cardia":
                                                            this.writeInput("record", "s", "306");
                                                            break;
                                                        case "fundus":
                                                            this.writeInput("record", "s", "307");
                                                            break;
                                                        case "bulb":
                                                            this.writeInput("record", "s", "308");
                                                            break;
                                                        case "sda":
                                                            this.writeInput("record", "s", "309");
                                                            break;
                                                        case "2nd portion":
                                                            this.writeInput("record", "s", "310");
                                                            break;
                                                        case "body":
                                                            this.writeInput("record", "s", "590");
                                                            break;
                                                        case "upper-body":
                                                            this.writeInput("record", "s", "591");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([12, 14].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bulb":
                                                            this.writeInput("record", "s", "308");
                                                            break;
                                                        case "2nd portion":
                                                            this.writeInput("record", "s", "310");
                                                            break;
                                                        case "sda":
                                                            this.writeInput("record", "s", "309");
                                                            break;
                                                        case "papilla":
                                                            this.writeInput("record", "s", "528");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cardia":
                                                            this.writeInput("record", "s", "306");
                                                            break;
                                                        case "fundus":
                                                            this.writeInput("record", "s", "307");
                                                            break;
                                                        case "high-body":
                                                            this.writeInput("record", "s", "304");
                                                            break;
                                                        case "upper-body":
                                                            this.writeInput("record", "s", "591");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cervical":
                                                            this.writeInput("record", "s", "296");
                                                            break;
                                                        case "upper":
                                                            this.writeInput("record", "s", "297");
                                                            break;
                                                        case "middle":
                                                            this.writeInput("record", "s", "298");
                                                            break;
                                                        case "lower":
                                                            this.writeInput("record", "s", "299");
                                                            break;
                                                        case "ecj":
                                                            this.writeInput("record", "s", "300");
                                                            break;
                                                        case "antrum":
                                                            this.writeInput("record", "s", "301");
                                                            break;
                                                        case "low-body":
                                                            this.writeInput("record", "s", "302");
                                                            break;
                                                        case "mid-body":
                                                            this.writeInput("record", "s", "303");
                                                            break;
                                                        case "high-body":
                                                            this.writeInput("record", "s", "304");
                                                            break;
                                                        case "angle":
                                                            this.writeInput("record", "s", "305");
                                                            break;
                                                        case "cardia":
                                                            this.writeInput("record", "s", "306");
                                                            break;
                                                        case "fundus":
                                                            this.writeInput("record", "s", "307");
                                                            break;
                                                        case "body":
                                                            this.writeInput("record", "s", "590");
                                                            break;
                                                        case "upper-body":
                                                            this.writeInput("record", "s", "591");
                                                            break;
                                                        case "bulb":
                                                            this.writeInput("record", "s", "308");
                                                            break;
                                                        case "2nd portion":
                                                            this.writeInput("record", "s", "310");
                                                            break;
                                                        case "sda":
                                                            this.writeInput("record", "s", "309");
                                                            break;
                                                        case "papilla":
                                                            this.writeInput("record", "s", "528");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "terminal ileum":
                                                            this.writeInput("record", "s", "312");
                                                            break;
                                                        case "ileocecal valve":
                                                            this.writeInput("record", "s", "313");
                                                            break;
                                                        case "appendix orifice":
                                                            this.writeInput("record", "s", "314");
                                                            break;
                                                        case "cecum":
                                                            this.writeInput("record", "s", "315");
                                                            break;
                                                        case "ascending colon":
                                                            this.writeInput("record", "s", "316");
                                                            break;
                                                        case "hepatic flexure":
                                                            this.writeInput("record", "s", "317");
                                                            break;
                                                        case "transverse colon":
                                                            this.writeInput("record", "s", "318");
                                                            break;
                                                        case "splenic flexure":
                                                            this.writeInput("record", "s", "319");
                                                            break;
                                                        case "descending colon":
                                                            this.writeInput("record", "s", "320");
                                                            break;
                                                        case "sigmoid colon":
                                                            this.writeInput("record", "s", "321");
                                                            break;
                                                        case "rs junction":
                                                            this.writeInput("record", "s", "322");
                                                            break;
                                                        case "rectum":
                                                            this.writeInput("record", "s", "323");
                                                            break;
                                                        case "anus":
                                                            this.writeInput("record", "s", "529");
                                                            break;
                                                        case "all segments of colon":
                                                            this.writeInput("record", "s", "530");
                                                            break;
                                                        case "anastomosis":
                                                            this.writeInput("record", "s", "563");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([34].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "internal":
                                                            this.writeInput("record", "s", "502");
                                                            break;
                                                        case "external":
                                                            this.writeInput("record", "s", "503");
                                                            break;
                                                        case "mixed":
                                                            this.writeInput("record", "s", "504");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "terminal ileum":
                                                            this.writeInput("record", "s", "312");
                                                            break;
                                                        case "ileocecal valve":
                                                            this.writeInput("record", "s", "313");
                                                            break;
                                                        case "appendix orifice":
                                                            this.writeInput("record", "s", "314");
                                                            break;
                                                        case "cecum":
                                                            this.writeInput("record", "s", "315");
                                                            break;
                                                        case "ascending colon":
                                                            this.writeInput("record", "s", "316");
                                                            break;
                                                        case "hepatic flexure":
                                                            this.writeInput("record", "s", "317");
                                                            break;
                                                        case "transverse colon":
                                                            this.writeInput("record", "s", "318");
                                                            break;
                                                        case "splenic flexure":
                                                            this.writeInput("record", "s", "319");
                                                            break;
                                                        case "descending colon":
                                                            this.writeInput("record", "s", "320");
                                                            break;
                                                        case "sigmoid colon":
                                                            this.writeInput("record", "s", "321");
                                                            break;
                                                        case "rs junction":
                                                            this.writeInput("record", "s", "322");
                                                            break;
                                                        case "rectum":
                                                            this.writeInput("record", "s", "323");
                                                            break;
                                                        case "anus":
                                                            this.writeInput("record", "s", "529");
                                                            break;
                                                        case "all segments of colon":
                                                            this.writeInput("record", "s", "530");
                                                            break;
                                                        case "anastomosis":
                                                            this.writeInput("record", "s", "563");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                } else if ([34].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "internal":
                                                            this.writeInput("record", "s", "502");
                                                            break;
                                                        case "external":
                                                            this.writeInput("record", "s", "503");
                                                            break;
                                                        case "mixed":
                                                            this.writeInput("record", "s", "504");
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                                                if (this.examinationLocations[(Number(voiceInput) - 1)]) {
                                                                    // 設定 nowLocationsIndex
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'nowLocationsIndex',
                                                                        value: (Number(voiceInput) - 1)
                                                                    });
                                                                    // 設定 focus
                                                                    this.setStoreHiddenParameter({
                                                                        target: 'focus',
                                                                        value: 'loca'
                                                                    });
                                                                    resolve();
                                                                }
                                                            }
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hotSnare":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([9, 10, 11, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hot snare":
                                                            this.writeInput("record", "c2", 63);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hot snare":
                                                            this.writeInput("record", "c2", 63);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hot snare":
                                                            this.writeInput("record", "c2", 63);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "emer":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "emergent":
                                                            this.writeInput("record", "c2", 64);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "emergent":
                                                            this.writeInput("record", "c2", 64);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "emergent":
                                                            this.writeInput("record", "c2", 64);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "mayo":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "0":
                                                            this.writeInput("record", "s", "329");
                                                            break;
                                                        case "1":
                                                            this.writeInput("record", "s", "330");
                                                            break;
                                                        case "2":
                                                            this.writeInput("record", "s", "331");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "332");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "0":
                                                            this.writeInput("record", "s", "329");
                                                            break;
                                                        case "1":
                                                            this.writeInput("record", "s", "330");
                                                            break;
                                                        case "2":
                                                            this.writeInput("record", "s", "331");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "332");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "morph":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ip":
                                                            this.writeInput("record", "s", "345");
                                                            break;
                                                        case "is":
                                                            this.writeInput("record", "s", "346");
                                                            break;
                                                        case "iia":
                                                            this.writeInput("record", "s", "347");
                                                            break;
                                                        case "iib":
                                                            this.writeInput("record", "s", "348");
                                                            break;
                                                        case "iic":
                                                            this.writeInput("record", "s", "349");
                                                            break;
                                                        case "iia+c":
                                                            this.writeInput("record", "s", "340");
                                                            break;
                                                        case "iic+a":
                                                            this.writeInput("record", "s", "341");
                                                            break;
                                                        case "iic+iii":
                                                            this.writeInput("record", "s", "350");
                                                            break;
                                                        case "iii":
                                                            this.writeInput("record", "s", "351");
                                                            break;
                                                        case "i-sp":
                                                            this.writeInput("record", "s", "589");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "0":
                                                            this.writeInput("record", "s", "333");
                                                            break;
                                                        case "0-ip":
                                                            this.writeInput("record", "s", "334");
                                                            break;
                                                        case "0-is":
                                                            this.writeInput("record", "s", "335");
                                                            break;
                                                        case "0-iia":
                                                            this.writeInput("record", "s", "336");
                                                            break;
                                                        case "0-iib":
                                                            this.writeInput("record", "s", "337");
                                                            break;
                                                        case "0-iic":
                                                            this.writeInput("record", "s", "338");
                                                            break;
                                                        case "0-iii":
                                                            this.writeInput("record", "s", "339");
                                                            break;
                                                        case "iia+c":
                                                            this.writeInput("record", "s", "340");
                                                            break;
                                                        case "iic+a":
                                                            this.writeInput("record", "s", "341");
                                                            break;
                                                        case "iic+iii":
                                                            this.writeInput("record", "s", "342");
                                                            break;
                                                        case "lst-g":
                                                            this.writeInput("record", "s", "343");
                                                            break;
                                                        case "lst-ng":
                                                            this.writeInput("record", "s", "344");
                                                            break;
                                                        case "i-sp":
                                                            this.writeInput("record", "s", "589");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "0":
                                                            this.writeInput("record", "s", "333");
                                                            break;
                                                        case "0-ip":
                                                            this.writeInput("record", "s", "334");
                                                            break;
                                                        case "0-is":
                                                            this.writeInput("record", "s", "335");
                                                            break;
                                                        case "0-iia":
                                                            this.writeInput("record", "s", "336");
                                                            break;
                                                        case "0-iib":
                                                            this.writeInput("record", "s", "337");
                                                            break;
                                                        case "0-iic":
                                                            this.writeInput("record", "s", "338");
                                                            break;
                                                        case "0-iii":
                                                            this.writeInput("record", "s", "339");
                                                            break;
                                                        case "iia+c":
                                                            this.writeInput("record", "s", "340");
                                                            break;
                                                        case "iic+a":
                                                            this.writeInput("record", "s", "341");
                                                            break;
                                                        case "iic+iii":
                                                            this.writeInput("record", "s", "342");
                                                            break;
                                                        case "lst-g":
                                                            this.writeInput("record", "s", "343");
                                                            break;
                                                        case "lst-ng":
                                                            this.writeInput("record", "s", "344");
                                                            break;
                                                        case "i-sp":
                                                            this.writeInput("record", "s", "589");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "nice":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "1":
                                                            this.writeInput("record", "s", "352");
                                                            break;
                                                        case "2":
                                                            this.writeInput("record", "s", "353");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "354");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "1":
                                                            this.writeInput("record", "s", "352");
                                                            break;
                                                        case "2":
                                                            this.writeInput("record", "s", "353");
                                                            break;
                                                        case "3":
                                                            this.writeInput("record", "s", "354");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "number":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "several":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        case "multiple":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput)) {
                                                                this.writeInput("finding", "t", voiceInput);
                                                            }
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 553, 557, 560, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "several":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        case "multiple":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput)) {
                                                                this.writeInput("finding", "t", voiceInput);
                                                            }
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 553, 557, 560, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "several":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        case "multiple":
                                                            this.writeInput("finding", "t", voiceInput);
                                                            break;
                                                        default:
                                                            checkInt = /^[0-9]*[1-9][0-9]*$/
                                                            if (checkInt.test(voiceInput)) {
                                                                this.writeInput("finding", "t", voiceInput);
                                                            }
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "object":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "t", voiceInput);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "t", voiceInput);
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "orien":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 8, 9, 10, 11, 12, 14, 16, 39, 40, 41, 42, 43, 45, 46, 47, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574, 559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "aw":
                                                            this.writeInput("record", "s", "359");
                                                            break;
                                                        case "pw":
                                                            this.writeInput("record", "s", "360");
                                                            break;
                                                        case "gc":
                                                            this.writeInput("record", "s", "361");
                                                            break;
                                                        case "lc":
                                                            this.writeInput("record", "s", "362");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "proximal":
                                                            this.writeInput("record", "s", "324");
                                                            break;
                                                        case "middle":
                                                            this.writeInput("record", "s", "325");
                                                            break;
                                                        case "distal":
                                                            this.writeInput("record", "s", "326");
                                                            break;
                                                        case "upper":
                                                            this.writeInput("record", "s", "327");
                                                            break;
                                                        case "lower":
                                                            this.writeInput("record", "s", "328");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 557, 558, 559, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "proximal":
                                                            this.writeInput("record", "s", "324");
                                                            break;
                                                        case "middle":
                                                            this.writeInput("record", "s", "325");
                                                            break;
                                                        case "distal":
                                                            this.writeInput("record", "s", "326");
                                                            break;
                                                        case "upper":
                                                            this.writeInput("record", "s", "327");
                                                            break;
                                                        case "lower":
                                                            this.writeInput("record", "s", "328");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "paris":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "0-i":
                                                            this.writeInput("record", "s", "363");
                                                            break;
                                                        case "0-iia":
                                                            this.writeInput("record", "s", "364");
                                                            break;
                                                        case "0-iib":
                                                            this.writeInput("record", "s", "365");
                                                            break;
                                                        case "0-iic":
                                                            this.writeInput("record", "s", "366");
                                                            break;
                                                        case "0-iii":
                                                            this.writeInput("record", "s", "367");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "prgC":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "prgM":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "rcs":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "negative":
                                                            this.writeInput("record", "c", 428);
                                                            break;
                                                        case "red whale marking":
                                                            this.writeInput("record", "c", 429);
                                                            break;
                                                        case "cherry-red spot":
                                                            this.writeInput("record", "c", 430);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "removed":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "431");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "432");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([51].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "431");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "432");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "ro":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "early cancer":
                                                            this.writeInput("record", "s", "433");
                                                            break;
                                                        case "advanced cancer":
                                                            this.writeInput("record", "s", "434");
                                                            break;
                                                    }
                                                } else if ([8].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([9].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "fundal gland polyp":
                                                            this.writeInput("record", "c", 462);
                                                            break;
                                                        case "adenomatous polyp":
                                                            this.writeInput("record", "c", 463);
                                                            break;
                                                        case "hyperplastic polyp":
                                                            this.writeInput("record", "c", 464);
                                                            break;
                                                        case "gastric ca":
                                                            this.writeInput("record", "c", 465);
                                                            break;
                                                        case "fap":
                                                            this.writeInput("record", "c", 466);
                                                            break;
                                                    }
                                                } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "lipoma":
                                                            this.writeInput("record", "c", 469);
                                                            break;
                                                        case "carcinoid tumor":
                                                            this.writeInput("record", "c", 470);
                                                            break;
                                                        case "lymphoma":
                                                            this.writeInput("record", "c", 476);
                                                            break;
                                                        case "hemangioma":
                                                            this.writeInput("record", "c", 477);
                                                            break;
                                                        case "gist":
                                                            this.writeInput("record", "c", 471);
                                                            break;
                                                        case "metastatic tumor":
                                                            this.writeInput("record", "c", 472);
                                                            break;
                                                        case "extraluminal impression":
                                                            this.writeInput("record", "c", 473);
                                                            break;
                                                        case "net":
                                                            this.writeInput("record", "c", 475);
                                                            break;
                                                    }
                                                } else if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "dysplasia":
                                                            this.writeInput("record", "s", "488");
                                                            break;
                                                        case "cancer":
                                                            this.writeInput("record", "s", "489");
                                                            break;
                                                    }
                                                } else if ([566].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([567].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([568].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([569].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([570].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "portal hypertensive gastropathy":
                                                            this.writeInput("record", "c", 458);
                                                            break;
                                                    }
                                                } else if ([571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "acute gastritis":
                                                            this.writeInput("record", "c", 453);
                                                            break;
                                                        case "hemorrhagic gastritis":
                                                            this.writeInput("record", "c", 454);
                                                            break;
                                                        case "chronic gastritis":
                                                            this.writeInput("record", "c", 455);
                                                            break;
                                                        case "superficial gastritis":
                                                            this.writeInput("record", "c", 456);
                                                            break;
                                                        case "atrophic gastritis":
                                                            this.writeInput("record", "c", 457);
                                                            break;
                                                    }
                                                } else if ([572].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "adenomatous polyp":
                                                            this.writeInput("record", "c", 463);
                                                            break;
                                                        case "hyperplastic polyp":
                                                            this.writeInput("record", "c", 464);
                                                            break;
                                                        case "gastric ca":
                                                            this.writeInput("record", "c", 465);
                                                            break;
                                                        case "fap":
                                                            this.writeInput("record", "c", 466);
                                                            break;
                                                    }
                                                } else if ([573].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "fundal gland polyp":
                                                            this.writeInput("record", "c", 462);
                                                            break;
                                                        case "hyperplastic polyp":
                                                            this.writeInput("record", "c", 464);
                                                            break;
                                                        case "gastric ca":
                                                            this.writeInput("record", "c", 465);
                                                            break;
                                                        case "fap":
                                                            this.writeInput("record", "c", 466);
                                                            break;
                                                    }
                                                } else if ([540].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "fundal gland polyp":
                                                            this.writeInput("record", "c", 462);
                                                            break;
                                                        case "adenomatous polyp":
                                                            this.writeInput("record", "c", 463);
                                                            break;
                                                        case "gastric ca":
                                                            this.writeInput("record", "c", 465);
                                                            break;
                                                        case "fap":
                                                            this.writeInput("record", "c", 466);
                                                            break;
                                                    }
                                                } else if ([574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "fundal gland polyp":
                                                            this.writeInput("record", "c", 462);
                                                            break;
                                                        case "adenomatous polyp":
                                                            this.writeInput("record", "c", 463);
                                                            break;
                                                        case "hyperplastic polyp":
                                                            this.writeInput("record", "c", 464);
                                                            break;
                                                        case "gastric ca":
                                                            this.writeInput("record", "c", 465);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                        case "malignancy":
                                                            this.writeInput("record", "c", 436);
                                                            break;
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                    }
                                                } else if ([23, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([35, 36].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "c", 459);
                                                            break;
                                                        case "diverticulitis":
                                                            this.writeInput("record", "c", 460);
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "c", 461);
                                                            break;
                                                    }
                                                } else if ([50].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "tb related lesion":
                                                            this.writeInput("record", "c", 467);
                                                            break;
                                                        case "amoeba":
                                                            this.writeInput("record", "c", 468);
                                                            break;
                                                    }
                                                } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "lipoma":
                                                            this.writeInput("record", "c", 469);
                                                            break;
                                                        case "carcinoid tumor":
                                                            this.writeInput("record", "c", 470);
                                                            break;
                                                        case "gist":
                                                            this.writeInput("record", "c", 471);
                                                            break;
                                                        case "metastatic tumor":
                                                            this.writeInput("record", "c", 472);
                                                            break;
                                                        case "extraluminal impression":
                                                            this.writeInput("record", "c", 473);
                                                            break;
                                                        case "appendiceal tumor":
                                                            this.writeInput("record", "c", 474);
                                                            break;
                                                        case "net":
                                                            this.writeInput("record", "c", 475);
                                                            break;
                                                        case "lymphoma":
                                                            this.writeInput("record", "c", 476);
                                                            break;
                                                        case "hemangioma":
                                                            this.writeInput("record", "c", 477);
                                                            break;
                                                        case "lymphangioma":
                                                            this.writeInput("record", "c", 562);
                                                            break;
                                                    }
                                                } else if ([48, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([37].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulitis":
                                                            this.writeInput("record", "s", "460");
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "s", "461");
                                                            break;
                                                    }
                                                } else if ([564].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "s", "459");
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "s", "461");
                                                            break;
                                                    }
                                                } else if ([24].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([25].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([26].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([27].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([28].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([29].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([30].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([31].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([32].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([33].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                    }
                                                } else if ([578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "c", 459);
                                                            break;
                                                    }
                                                } else if ([579, 580].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([581].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                        case "malignancy":
                                                            this.writeInput("record", "c", 436);
                                                            break;
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                    }
                                                } else if ([23, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([35, 36].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "c", 459);
                                                            break;
                                                        case "diverticulitis":
                                                            this.writeInput("record", "c", 460);
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "c", 461);
                                                            break;
                                                    }
                                                } else if ([50].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "tb related lesion":
                                                            this.writeInput("record", "c", 467);
                                                            break;
                                                        case "amoeba":
                                                            this.writeInput("record", "c", 468);
                                                            break;
                                                    }
                                                } else if ([10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "lipoma":
                                                            this.writeInput("record", "c", 469);
                                                            break;
                                                        case "carcinoid tumor":
                                                            this.writeInput("record", "c", 470);
                                                            break;
                                                        case "gist":
                                                            this.writeInput("record", "c", 471);
                                                            break;
                                                        case "metastatic tumor":
                                                            this.writeInput("record", "c", 472);
                                                            break;
                                                        case "extraluminal impression":
                                                            this.writeInput("record", "c", 473);
                                                            break;
                                                        case "appendiceal tumor":
                                                            this.writeInput("record", "c", 474);
                                                            break;
                                                        case "net":
                                                            this.writeInput("record", "c", 475);
                                                            break;
                                                        case "lymphoma":
                                                            this.writeInput("record", "c", 476);
                                                            break;
                                                        case "hemangioma":
                                                            this.writeInput("record", "c", 477);
                                                            break;
                                                        case "lymphangioma":
                                                            this.writeInput("record", "c", 562);
                                                            break;
                                                    }
                                                } else if ([48, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([37].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulitis":
                                                            this.writeInput("record", "s", "460");
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "s", "461");
                                                            break;
                                                    }
                                                } else if ([564].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "s", "459");
                                                            break;
                                                        case "diverticular bleeding":
                                                            this.writeInput("record", "s", "461");
                                                            break;
                                                    }
                                                } else if ([24].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([25].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([26].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([27].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([28].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([29].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([30].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([31].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([32].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "proctitis":
                                                            this.writeInput("record", "c", 435);
                                                            break;
                                                    }
                                                } else if ([33].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "ibd":
                                                            this.writeInput("record", "c", 437);
                                                            break;
                                                        case "ulcerative colitis":
                                                            this.writeInput("record", "c", 438);
                                                            break;
                                                        case "crohn's disease":
                                                            this.writeInput("record", "c", 439);
                                                            break;
                                                        case "pseudomembranous colitis":
                                                            this.writeInput("record", "c", 445);
                                                            break;
                                                        case "ischemic colitis":
                                                            this.writeInput("record", "c", 444);
                                                            break;
                                                        case "infectious colitis":
                                                            this.writeInput("record", "c", 440);
                                                            break;
                                                        case "tb colitis":
                                                            this.writeInput("record", "c", 441);
                                                            break;
                                                        case "amoebic colitis":
                                                            this.writeInput("record", "c", 442);
                                                            break;
                                                        case "radiation colitis":
                                                            this.writeInput("record", "c", 443);
                                                            break;
                                                    }
                                                } else if ([578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diverticulosis":
                                                            this.writeInput("record", "c", 459);
                                                            break;
                                                    }
                                                } else if ([579, 580].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([581].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "unknown bleeder":
                                                            this.writeInput("record", "c", 487);
                                                            break;
                                                    }
                                                } else if ([582].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "upper gi":
                                                            this.writeInput("record", "c", 484);
                                                            break;
                                                        case "lower gi":
                                                            this.writeInput("record", "c", 485);
                                                            break;
                                                        case "occult bleeding":
                                                            this.writeInput("record", "c", 486);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "sign":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding":
                                                            this.writeInput("record", "c", 490);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 491);
                                                            break;
                                                        case "bezoar":
                                                            this.writeInput("record", "c", 492);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding":
                                                            this.writeInput("record", "c", 490);
                                                            break;
                                                        case "inflammation":
                                                            this.writeInput("record", "c", 491);
                                                            break;
                                                        case "bezoar":
                                                            this.writeInput("record", "c", 492);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "size":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "t", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "t", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "t", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "skipLesion":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "494");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "495");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "yes":
                                                            this.writeInput("record", "s", "494");
                                                            break;
                                                        case "no":
                                                            this.writeInput("record", "s", "495");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "sorP":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([9, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sessile":
                                                            this.writeInput("record", "s", "517");
                                                            break;
                                                        case "pedunculated":
                                                            this.writeInput("record", "s", "518");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 540, 541, 542, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sessile":
                                                            this.writeInput("record", "s", "517");
                                                            break;
                                                        case "pedunculated":
                                                            this.writeInput("record", "s", "518");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 540, 541, 542, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sessile":
                                                            this.writeInput("record", "s", "517");
                                                            break;
                                                        case "pedunculated":
                                                            this.writeInput("record", "s", "518");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "sPat":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "regular":
                                                            this.writeInput("record", "s", "496");
                                                            break;
                                                        case "irregular":
                                                            this.writeInput("record", "s", "497");
                                                            break;
                                                        case "absent":
                                                            this.writeInput("record", "s", "498");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "takeNote":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 9, 10, 12, 39, 40, 41, 42, 43, 45, 46, 47, 4, 15, 11, 13, 16, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "the most significant":
                                                            this.writeInput("finding", "s", "499");
                                                            break;
                                                        case "each":
                                                            this.writeInput("finding", "s", "500");
                                                            break;
                                                        case "overall":
                                                            this.writeInput("finding", "s", "501");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 21, 22, 540, 541, 542, 551, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553, 548, 17, 18, 19, 20, 57, 543, 544, 545, 546, 547, 549, 550, 557].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "the most significant":
                                                            this.writeInput("finding", "s", "499");
                                                            break;
                                                        case "each":
                                                            this.writeInput("finding", "s", "500");
                                                            break;
                                                        case "overall":
                                                            this.writeInput("finding", "s", "501");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 21, 22, 540, 541, 542, 551, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 553, 548, 17, 18, 19, 20, 57, 543, 544, 545, 546, 547, 549, 550, 557].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "the most significant":
                                                            this.writeInput("finding", "s", "499");
                                                            break;
                                                        case "each":
                                                            this.writeInput("finding", "s", "500");
                                                            break;
                                                        case "overall":
                                                            this.writeInput("finding", "s", "501");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "ulcerStage":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "active":
                                                            this.writeInput("record", "s", "505");
                                                            break;
                                                        case "healing":
                                                            this.writeInput("record", "s", "506");
                                                            break;
                                                        case "scar":
                                                            this.writeInput("record", "s", "507");
                                                            break;
                                                        case "a1":
                                                            this.writeInput("record", "s", "508");
                                                            break;
                                                        case "a2":
                                                            this.writeInput("record", "s", "509");
                                                            break;
                                                        case "h1":
                                                            this.writeInput("record", "s", "510");
                                                            break;
                                                        case "h2":
                                                            this.writeInput("record", "s", "511");
                                                            break;
                                                        case "s1":
                                                            this.writeInput("record", "s", "512");
                                                            break;
                                                        case "s2":
                                                            this.writeInput("record", "s", "513");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "vPat":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "regular":
                                                            this.writeInput("record", "s", "514");
                                                            break;
                                                        case "irregular":
                                                            this.writeInput("record", "s", "515");
                                                            break;
                                                        case "absent":
                                                            this.writeInput("record", "s", "516");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "alligator":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "alligator":
                                                            this.writeInput("record", "c2", 148);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "alligator":
                                                            this.writeInput("record", "c2", 148);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "alligator":
                                                            this.writeInput("record", "c2", 148);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "apc":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "apc":
                                                            this.writeInput("record", "c2", 119);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "apc":
                                                            this.writeInput("record", "c2", 119);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "apc":
                                                            this.writeInput("record", "c2", 119);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "biopFor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 5, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy forceps":
                                                            this.writeInput("record", "c2", 145);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy forceps":
                                                            this.writeInput("record", "c2", 145);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy forceps":
                                                            this.writeInput("record", "c2", 145);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "bleedMinor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6, 1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "minor bleeding":
                                                            this.writeInput("record", "c2", 173);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "minor bleeding":
                                                            this.writeInput("record", "c2", 173);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "minor bleeding":
                                                            this.writeInput("record", "c2", 173);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "cap":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cap":
                                                            this.writeInput("record", "c2", 144);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cap":
                                                            this.writeInput("record", "c2", 144);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cap":
                                                            this.writeInput("record", "c2", 144);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "clip":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "cloLoca":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([7, 8, 11, 12, 16, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "pylorus":
                                                            this.writeInput("record", "c", 153);
                                                            break;
                                                        case "antrum":
                                                            this.writeInput("record", "c", 154);
                                                            break;
                                                        case "low-body":
                                                            this.writeInput("record", "c", 155);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "coag":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "coagrasper":
                                                            this.writeInput("record", "c2", 120);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "coagrasper":
                                                            this.writeInput("record", "c2", 120);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "coagrasper":
                                                            this.writeInput("record", "c2", 120);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "coldSnare":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([9, 10, 11, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cold snare":
                                                            this.writeInput("record", "c2", 156);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cold snare":
                                                            this.writeInput("record", "c2", 156);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "cold snare":
                                                            this.writeInput("record", "c2", 156);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "perfor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "perforation":
                                                            this.writeInput("record", "s", "123");
                                                            break;
                                                        case "closed":
                                                            this.writeInput("record", "s", "124");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "perforation":
                                                            this.writeInput("record", "s", "123");
                                                            break;
                                                        case "closed":
                                                            this.writeInput("record", "s", "124");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "perforation":
                                                            this.writeInput("record", "s", "123");
                                                            break;
                                                        case "closed":
                                                            this.writeInput("record", "s", "124");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "comremove":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "completely removed":
                                                            this.writeInput("record", "c2", 88);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "completely removed":
                                                            this.writeInput("record", "c2", 88);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "completely removed":
                                                            this.writeInput("record", "c2", 88);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "diEpi":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diluted epinephrine":
                                                            this.writeInput("record", "c2", 122);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diluted epinephrine":
                                                            this.writeInput("record", "c2", 122);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "diluted epinephrine":
                                                            this.writeInput("record", "c2", 122);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "dualK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "dualknife":
                                                            this.writeInput("record", "c2", 133);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "dualknife":
                                                            this.writeInput("record", "c2", 133);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "dualknife":
                                                            this.writeInput("record", "c2", 133);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "ele":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elective":
                                                            this.writeInput("record", "c2", 158);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elective":
                                                            this.writeInput("record", "c2", 158);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "elective":
                                                            this.writeInput("record", "c2", 158);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "enbloc":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "en bloc":
                                                            this.writeInput("record", "c2", 152);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "en bloc":
                                                            this.writeInput("record", "c2", 152);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "en bloc":
                                                            this.writeInput("record", "c2", 152);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "endolift":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endolifter":
                                                            this.writeInput("record", "c2", 143);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endolifter":
                                                            this.writeInput("record", "c2", 143);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endolifter":
                                                            this.writeInput("record", "c2", 143);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "endoloop":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endoloop":
                                                            this.writeInput("record", "c2", 151);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endoloop":
                                                            this.writeInput("record", "c2", 151);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "endoloop":
                                                            this.writeInput("record", "c2", 151);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "flexK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "flexknife":
                                                            this.writeInput("record", "c2", 139);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "flexknife":
                                                            this.writeInput("record", "c2", 139);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "flexknife":
                                                            this.writeInput("record", "c2", 139);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "glyce":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "glycerol":
                                                            this.writeInput("record", "c2", 128);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "glycerol":
                                                            this.writeInput("record", "c2", 128);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "glycerol":
                                                            this.writeInput("record", "c2", 128);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "graFor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 6, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "grasping forceps":
                                                            this.writeInput("record", "c2", 146);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "grasping forceps":
                                                            this.writeInput("record", "c2", 146);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "grasping forceps":
                                                            this.writeInput("record", "c2", 146);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "histo":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "histoacryl":
                                                            this.writeInput("record", "c2", 160);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hookK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hookknife":
                                                            this.writeInput("record", "c2", 138);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hookknife":
                                                            this.writeInput("record", "c2", 138);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hookknife":
                                                            this.writeInput("record", "c2", 138);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hProbe":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "heater probe":
                                                            this.writeInput("record", "c2", 121);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "heater probe":
                                                            this.writeInput("record", "c2", 121);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "heater probe":
                                                            this.writeInput("record", "c2", 121);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hyAcid":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hyaluronic acid":
                                                            this.writeInput("record", "c2", 129);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hyaluronic acid":
                                                            this.writeInput("record", "c2", 129);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hyaluronic acid":
                                                            this.writeInput("record", "c2", 129);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "hybridK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hybrid knife":
                                                            this.writeInput("record", "c2", 141);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hybrid knife":
                                                            this.writeInput("record", "c2", 141);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hybrid knife":
                                                            this.writeInput("record", "c2", 141);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "indigo":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "indigo carmine":
                                                            this.writeInput("record", "c2", 131);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "indigo carmine":
                                                            this.writeInput("record", "c2", 131);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "indigo carmine":
                                                            this.writeInput("record", "c2", 131);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "interven":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 565].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "arms":
                                                            this.writeInput("record", "s", "54");
                                                            break;
                                                        case "stretta":
                                                            this.writeInput("record", "s", "55");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([7, 12].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "clo":
                                                            this.writeInput("record", "s", "56");
                                                            break;
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([14].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([4, 15].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "rfa":
                                                            this.writeInput("record", "s", "62");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([8, 566, 567, 568, 569, 570, 571].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "clo":
                                                            this.writeInput("record", "s", "56");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([9, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([11, 16].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "clo":
                                                            this.writeInput("record", "s", "56");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([2].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "rfa":
                                                            this.writeInput("record", "s", "62");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([10, 39, 40, 41, 42, 43, 45, 46, 47].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "ster":
                                                            this.writeInput("record", "s", "66");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([5].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "evl":
                                                            this.writeInput("record", "s", "519");
                                                            break;
                                                        case "eis":
                                                            this.writeInput("record", "s", "520");
                                                            break;
                                                        case "sb tube":
                                                            this.writeInput("record", "s", "521");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "gvl":
                                                            this.writeInput("record", "s", "522");
                                                            break;
                                                        case "gis":
                                                            this.writeInput("record", "s", "523");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([3, 13, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.colonPolypectomyFocus = true
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([38, 50, 52, 558].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "bezoar removal":
                                                            this.writeInput("record", "s", "65");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([561].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "band ligation":
                                                            this.writeInput("record", "s", "524");
                                                            break;
                                                        case "sclerotherapy":
                                                            this.writeInput("record", "s", "525");
                                                            break;
                                                        case "infrared coagulation":
                                                            this.writeInput("record", "s", "526");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([57, 543, 544, 545, 546, 547, 549, 550].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([48, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 560].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([49, 51, 554, 556, 557, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([555, 559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 39, 40, 41, 42, 43, 44, 45, 46, 47, 540, 541, 542, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([38, 50, 52, 558].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([21, 22, 551].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "bezoar removal":
                                                            this.writeInput("record", "s", "65");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([561].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "band ligation":
                                                            this.writeInput("record", "s", "524");
                                                            break;
                                                        case "sclerotherapy":
                                                            this.writeInput("record", "s", "525");
                                                            break;
                                                        case "infrared coagulation":
                                                            this.writeInput("record", "s", "526");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([57, 543, 544, 545, 546, 547, 549, 550].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "s/p endolooping":
                                                            this.writeInput("record", "s", "533");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([17, 18, 19, 20, 10].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "polypectomy":
                                                            this.writeInput("record", "s", "59");
                                                            break;
                                                        case "snare":
                                                            this.writeInput("record", "s", "74");
                                                            break;
                                                        case "cold snare":
                                                            this.writeInput("record", "s", "75");
                                                            break;
                                                        case "hot snare":
                                                            this.writeInput("record", "s", "76");
                                                            break;
                                                        case "emr":
                                                            this.writeInput("record", "s", "60");
                                                            break;
                                                        case "esd":
                                                            this.writeInput("record", "s", "61");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([48, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "s/p tattooing":
                                                            this.writeInput("record", "s", "534");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 552, 560].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "biopsy":
                                                            this.writeInput("record", "s", "53");
                                                            break;
                                                        case "hot biopsy":
                                                            this.writeInput("record", "s", "71");
                                                            break;
                                                        case "cold biopsy":
                                                            this.writeInput("record", "s", "73");
                                                            break;
                                                        case "hemostasis":
                                                            this.writeInput("record", "s", "58");
                                                            break;
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([49, 51, 554, 556, 557, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                } else if ([555, 559, 587, 588].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "s/p stenting":
                                                            this.writeInput("record", "s", "535");
                                                            break;
                                                        case "other":
                                                            this.writeInput("record", "s", "536");
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "itK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife":
                                                            this.writeInput("record", "c2", 134);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife":
                                                            this.writeInput("record", "c2", 134);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife":
                                                            this.writeInput("record", "c2", 134);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "itK2":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife-2":
                                                            this.writeInput("record", "c2", 135);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife-2":
                                                            this.writeInput("record", "c2", 135);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife-2":
                                                            this.writeInput("record", "c2", 135);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "itKnano":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife nano":
                                                            this.writeInput("record", "c2", 136);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife nano":
                                                            this.writeInput("record", "c2", 136);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "itknife nano":
                                                            this.writeInput("record", "c2", 136);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "label":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "t", voiceInput);
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "t", voiceInput);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "t", voiceInput);
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "lipi":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "lipiodol":
                                                            this.writeInput("record", "c2", 161);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "neeK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "needle knife":
                                                            this.writeInput("record", "c2", 140);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "needle knife":
                                                            this.writeInput("record", "c2", 140);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "needle knife":
                                                            this.writeInput("record", "c2", 140);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "net":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "net":
                                                            this.writeInput("record", "c2", 147);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "net":
                                                            this.writeInput("record", "c2", 147);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "net":
                                                            this.writeInput("record", "c2", 147);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "pentaFor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "pentapod grasping forceps":
                                                            this.writeInput("record", "c2", 150);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "pentapod grasping forceps":
                                                            this.writeInput("record", "c2", 150);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "pentapod grasping forceps":
                                                            this.writeInput("record", "c2", 150);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "reFor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "removal forceps":
                                                            this.writeInput("record", "c2", 149);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "removal forceps":
                                                            this.writeInput("record", "c2", 149);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "removal forceps":
                                                            this.writeInput("record", "c2", 149);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "rubband":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 3: // Sigmoidoscopy
                                                if ([34, 575, 576, 577].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "saline":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 9, 10, 11, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "saline":
                                                            this.writeInput("record", "c2", 130);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "saline":
                                                            this.writeInput("record", "c2", 130);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // Sigmoidoscopy
                                                if ([9, 17, 18, 19, 20, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 553, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "saline":
                                                            this.writeInput("record", "c2", 130);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "sbtue":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sb tube":
                                                            this.writeInput("record", "c2", 172);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "snare":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "snare":
                                                            this.writeInput("record", "c2", 142);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "snare":
                                                            this.writeInput("record", "c2", 142);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "snare":
                                                            this.writeInput("record", "c2", 142);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "sucra":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 5, 6, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sucralfate gel":
                                                            this.writeInput("record", "c2", 132);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sucralfate gel":
                                                            this.writeInput("record", "c2", 132);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "sucralfate gel":
                                                            this.writeInput("record", "c2", 132);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "tissue":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 548].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    if (!isNaN(voiceInput)) {
                                                        this.writeInput("record", "n", voiceInput);
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "tooth":
                                        switch (Number(this.examination_typeID)) {
                                            case 2: // Colonoscopy
                                                if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tooth":
                                                            this.writeInput("record", "c2", 174);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([35, 36, 37, 564, 578].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "tooth":
                                                            this.writeInput("record", "c2", 174);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "triK":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([2, 4, 7, 9, 10, 11, 12, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "triangle knife":
                                                            this.writeInput("record", "c2", 137);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "triangle knife":
                                                            this.writeInput("record", "c2", 137);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 560, 561, 548, 37, 564, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "triangle knife":
                                                            this.writeInput("record", "c2", 137);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "bleedMajor":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6, 1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "major bleeding":
                                                            this.writeInput("record", "c2", 68);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "major bleeding":
                                                            this.writeInput("record", "c2", 68);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "major bleeding":
                                                            this.writeInput("record", "c2", 68);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "intervenOther":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 3, 13, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574, 559, 587, 588, 592, 593, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 49, 51, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 52, 57, 49, 51, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 595, 596, 594, 597].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    this.writeInput("record", "ta", voiceInput);
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "bleedStop":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6, 1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding stop":
                                                            this.writeInput("record", "c2", 69);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding stop":
                                                            this.writeInput("record", "c2", 69);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding stop":
                                                            this.writeInput("record", "c2", 69);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                    case "bleedContinue":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // Gastroscopy
                                                if ([5, 6, 1, 2, 4, 7, 8, 9, 10, 11, 12, 14, 15, 16, 39, 40, 41, 42, 43, 45, 46, 47, 565, 566, 567, 568, 569, 570, 571, 572, 573, 540, 574].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding continue":
                                                            this.writeInput("record", "c2", 70);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 2: // Colonoscopy
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding continue":
                                                            this.writeInput("record", "c2", 70);
                                                            break;
                                                    }
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                if ([34, 9, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 38, 10, 39, 40, 41, 42, 43, 44, 45, 46, 47, 50, 52, 57, 540, 541, 542, 543, 544, 545, 546, 547, 549, 550, 551, 552, 553, 558, 560, 35, 36, 48, 561, 548, 37, 564, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586].indexOf(Number(this.getFinding.questions.finding.value)) != -1) {
                                                    switch (voiceInput) {
                                                        case "bleeding continue":
                                                            this.writeInput("record", "c2", 70);
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                        resolve(); // here(7)
                                        break;
                                        //==========================================================================
                                        //※ 第三層的特例
                                        //==========================================================================
                                    case "before" :
                                        console.log('第三層 before')
                                        break;
                                    case "after" :
                                        console.log('第三層 after')
                                        break;
                                    case "landmark":
                                        // 參考 ExaminationDetailPage.vue 的 imgLandmarkChange
                                        // 依據 nowImgIndex 設定截圖 Landmark
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // 胃鏡
                                                var temp_obj = {
                                                    "cervical": "31",
                                                    "upper": "32",
                                                    "middle": "33",
                                                    "lower": "34",
                                                    "ecj": "35",
                                                    "antrum": "36",
                                                    "aw antrum": "37",
                                                    "pw antrum": "38",
                                                    "gc antrum": "39",
                                                    "lc antrum": "40",
                                                    "low-body": "41",
                                                    "aw low-body": "42",
                                                    "pw low-body": "43",
                                                    "gc low-body": "44",
                                                    "lc low-body": "45",
                                                    "mid-body": "46",
                                                    "aw mid-body": "47",
                                                    "pw mid-body": "48",
                                                    "gc mid-body": "49",
                                                    "lc mid-body": "50",
                                                    "high-body": "51",
                                                    "aw high-body": "52",
                                                    "pw high-body": "53",
                                                    "gc high-body": "54",
                                                    "lc high-body": "55",
                                                    "angle": "56",
                                                    "cardia": "57",
                                                    "fundus": "58",
                                                    "bulb": "59",
                                                    "sda": "60",
                                                    "2nd portion": "61",
                                                    "papilla": "62",
                                                    "body": "63",
                                                    "aw body": "64",
                                                    "pw body": "65",
                                                    "gc body": "66",
                                                    "lc body": "67",
                                                    "upper-body": "68",
                                                    "aw upper-body": "69",
                                                    "pw upper-body": "70",
                                                    "gc upper-body": "71",
                                                    "lc upper-body": "72"
                                                }
                                                break;
                                            case 2: // 大腸鏡
                                                var temp_obj = {
                                                    "terminal ileum": "1",
                                                    "ileocecal valve": "2",
                                                    "appendix orifice": "3",
                                                    "cecum": "4",
                                                    "ascending colon": "5",
                                                    "proximal ascending colon": "6",
                                                    "middle ascending colon": "7",
                                                    "distal ascending colon": "8",
                                                    "hepatic flexure": "9",
                                                    "transverse colon": "10",
                                                    "proximal transverse colon": "11",
                                                    "middle transverse colon": "12",
                                                    "distal transverse colon": "13",
                                                    "splenic flexure": "14",
                                                    "descending colon": "15",
                                                    "proximal descending colon": "16",
                                                    "middle descending colon": "17",
                                                    "distal descending colon": "18",
                                                    "sigmoid colon": "19",
                                                    "proximal sigmoid colon": "20",
                                                    "middle sigmoid colon": "21",
                                                    "distal sigmoid colon": "22",
                                                    "rs junction": "23",
                                                    "rectum": "24",
                                                    "upper rectum": "25",
                                                    "middle rectum": "26",
                                                    "lower rectum": "27",
                                                    "anus": "28",
                                                    "all segments of colon": "29",
                                                    "anastomosis": "30"
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                var temp_obj = {
                                                    "terminal ileum": "73",
                                                    "ileocecal valve": "74",
                                                    "appendix orifice": "75",
                                                    "cecum": "76",
                                                    "ascending colon": "77",
                                                    "proximal ascending colon": "78",
                                                    "middle ascending colon": "79",
                                                    "distal ascending colon": "80",
                                                    "hepatic flexure": "81",
                                                    "transverse colon": "82",
                                                    "proximal transverse colon": "83",
                                                    "middle transverse colon": "84",
                                                    "distal transverse colon": "85",
                                                    "splenic flexure": "86",
                                                    "descending colon": "87",
                                                    "proximal descending colon": "88",
                                                    "middle descending colon": "89",
                                                    "distal descending colon": "90",
                                                    "sigmoid colon": "91",
                                                    "proximal sigmoid colon": "92",
                                                    "middle sigmoid colon": "93",
                                                    "distal sigmoid colon": "94",
                                                    "rs junction": "95",
                                                    "rectum": "96",
                                                    "upper rectum": "97",
                                                    "middle rectum": "98",
                                                    "lower rectum": "99",
                                                    "anus": "100",
                                                    "all segments of colon": "101",
                                                    "anastomosis": "102"
                                                }
                                                break;
                                        }
                                        if (temp_obj[voiceInput]) {
                                            if (this.getAllImages != null && this.getImage) {
                                                var item = this.getImage;
                                                var updateObj = {
                                                    imgID: item.id,
                                                    newValue: temp_obj[voiceInput],
                                                    page: 'e',
                                                    insertionTo: this.isInsertionTo,
                                                };
                                                if (this.isInsertionTo) {
                                                    this.isInsertionTo = false
                                                }
                                                this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
                                                    .then(() => this.musicPlay('saved'));
                                            }
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "findingGroup":
                                        // 參考 ExaminationDetailPage.vue 的 moveImgFromAllToFinding
                                        // 依據 nowImgIndex 設定截圖 Finding 分群
                                        checkInt = /^[0-9]*[1-9][0-9]*$/
                                        if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                            if (this.getAllImages != null && this.getImage) {
                                                var item = this.getImage;
                                                var toFindingIndex = Number(voiceInput) - 1;
                                                var newValue = this.getExaminationData.findings[toFindingIndex].id;
                                                if (!isNaN(newValue)) {
                                                    var updateObj = {
                                                        imgID: item.id,
                                                        newValue
                                                    };
                                                    this.$store.dispatch('examinations/moveImgFromAllToFinding', updateObj);
                                                }
                                            }
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "switchLesion":
                                        checkInt = /^[0-9]*[1-9][0-9]*$/
                                        if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                            if (this.getFinding.records[(Number(voiceInput) - 1)]) {
                                                // 設定 nowRecordIndex
                                                this.setHiddenParameter(null, (Number(voiceInput) - 1));
                                                this.setStoreHiddenParameter({
                                                    target: 'nowLocationsIndex',
                                                    value: 0
                                                });
                                                this.setStoreHiddenParameter({
                                                    target: 'focus',
                                                    value: ''
                                                });
                                            }
                                        }
                                        resolve();
                                        break;
                                    case "clean_medID":
                                        var temp_obj = {
                                            "peg-els": 1,
                                            "phosphosoda": 2,
                                            "magnesium citrate": 3,
                                            "castor oil": 4,
                                            "dulcolax": 5,
                                            "enema": 6,
                                            "fleet": 7,
                                            "klean": 8,
                                            "bowklean": 9
                                        }
                                        if (temp_obj[voiceInput]) {
                                            this.setExaminationColumn('clean_medID', temp_obj[voiceInput]);
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "cleanScale":
                                        var temp_obj = {
                                            "poor": "1",
                                            "fair": "2",
                                            "good": "3",
                                            "excellent": "4"
                                        }
                                        if (temp_obj[voiceInput]) {
                                            this.setExaminationColumn('cleanScale', temp_obj[voiceInput]);
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "preparation":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // 胃鏡
                                                var temp_preparation_obj = {
                                                    "food debris": "1",
                                                    "food stasis": "2",
                                                    "food": "3"
                                                }
                                                var temp_preparationLoca_obj = {
                                                    "cervical": "31",
                                                    "upper": "32",
                                                    "middle": "33",
                                                    "lower": "34",
                                                    "ecj": "35",
                                                    "antrum": "36",
                                                    "aw antrum": "37",
                                                    "pw antrum": "38",
                                                    "gc antrum": "39",
                                                    "lc antrum": "40",
                                                    "low-body": "41",
                                                    "aw low-body": "42",
                                                    "pw low-body": "43",
                                                    "gc low-body": "44",
                                                    "lc low-body": "45",
                                                    "mid-body": "46",
                                                    "aw mid-body": "47",
                                                    "pw mid-body": "48",
                                                    "gc mid-body": "49",
                                                    "lc mid-body": "50",
                                                    "high-body": "51",
                                                    "aw high-body": "52",
                                                    "pw high-body": "53",
                                                    "gc high-body": "54",
                                                    "lc high-body": "55",
                                                    "angle": "56",
                                                    "cardia": "57",
                                                    "fundus": "58",
                                                    "bulb": "59",
                                                    "sda": "60",
                                                    "2nd portion": "61",
                                                    "papilla": "62",
                                                    "body": "63",
                                                    "aw body": "64",
                                                    "pw body": "65",
                                                    "gc body": "66",
                                                    "lc body": "67",
                                                    "upper-body": "68",
                                                    "aw upper-body": "69",
                                                    "pw upper-body": "70",
                                                    "gc upper-body": "71",
                                                    "lc upper-body": "72"
                                                }
                                                break;
                                            case 2: // 大腸鏡
                                                var temp_preparation_obj = {
                                                    "stool": "1",
                                                    "stool impaction": "2",
                                                    "stool stasis": "3"
                                                }
                                                var temp_preparationLoca_obj = {
                                                    "terminal ileum": "1",
                                                    "ileocecal valve": "2",
                                                    "appendix orifice": "3",
                                                    "cecum": "4",
                                                    "ascending colon": "5",
                                                    "proximal ascending colon": "6",
                                                    "middle ascending colon": "7",
                                                    "distal ascending colon": "8",
                                                    "hepatic flexure": "9",
                                                    "transverse colon": "10",
                                                    "proximal transverse colon": "11",
                                                    "middle transverse colon": "12",
                                                    "distal transverse colon": "13",
                                                    "splenic flexure": "14",
                                                    "descending colon": "15",
                                                    "proximal descending colon": "16",
                                                    "middle descending colon": "17",
                                                    "distal descending colon": "18",
                                                    "sigmoid colon": "19",
                                                    "proximal sigmoid colon": "20",
                                                    "middle sigmoid colon": "21",
                                                    "distal sigmoid colon": "22",
                                                    "rs junction": "23",
                                                    "rectum": "24",
                                                    "upper rectum": "25",
                                                    "middle rectum": "26",
                                                    "lower rectum": "27",
                                                    "anus": "28",
                                                    "all segments of colon": "29",
                                                    "anastomosis": "30"
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                var temp_preparation_obj = {
                                                    "stool": "1",
                                                    "stool impaction": "2",
                                                    "stool stasis": "3"
                                                }
                                                var temp_preparationLoca_obj = {
                                                    "terminal ileum": "73",
                                                    "ileocecal valve": "74",
                                                    "appendix orifice": "75",
                                                    "cecum": "76",
                                                    "ascending colon": "77",
                                                    "proximal ascending colon": "78",
                                                    "middle ascending colon": "79",
                                                    "distal ascending colon": "80",
                                                    "hepatic flexure": "81",
                                                    "transverse colon": "82",
                                                    "proximal transverse colon": "83",
                                                    "middle transverse colon": "84",
                                                    "distal transverse colon": "85",
                                                    "splenic flexure": "86",
                                                    "descending colon": "87",
                                                    "proximal descending colon": "88",
                                                    "middle descending colon": "89",
                                                    "distal descending colon": "90",
                                                    "sigmoid colon": "91",
                                                    "proximal sigmoid colon": "92",
                                                    "middle sigmoid colon": "93",
                                                    "distal sigmoid colon": "94",
                                                    "rs junction": "95",
                                                    "rectum": "96",
                                                    "upper rectum": "97",
                                                    "middle rectum": "98",
                                                    "lower rectum": "99",
                                                    "anus": "100",
                                                    "all segments of colon": "101",
                                                    "anastomosis": "102"
                                                }
                                                break;
                                        }
                                        if (temp_preparation_obj[voiceInput]) {
                                            this.setExaminationColumn('preparation', temp_preparation_obj[voiceInput]);
                                        }
                                        if (temp_preparationLoca_obj[voiceInput]) {
                                            if (this.getExaminationData.examination.preparationLoca.indexOf(Number(temp_preparationLoca_obj[voiceInput])) == -1) {
                                                this.getExaminationData.examination.preparationLoca.push(Number(temp_preparationLoca_obj[voiceInput]));
                                            } else {
                                                this.getExaminationData.examination.preparationLoca.splice(this.getExaminationData.examination.preparationLoca.indexOf(Number(temp_preparationLoca_obj[voiceInput])), 1);
                                            }
                                            this.setExaminationColumn('preparationLoca', this.getExaminationData.examination.preparationLoca.join(","));
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "insertionLevel":
                                        switch (Number(this.examination_typeID)) {
                                            case 1: // 胃鏡
                                                break;
                                            case 2: // 大腸鏡
                                                var temp_obj = {
                                                    "terminal ileum": "1",
                                                    "ileocecal valve": "2",
                                                    "appendix orifice": "3",
                                                    "cecum": "4",
                                                    "ascending colon": "5",
                                                    "proximal ascending colon": "6",
                                                    "middle ascending colon": "7",
                                                    "distal ascending colon": "8",
                                                    "hepatic flexure": "9",
                                                    "transverse colon": "10",
                                                    "proximal transverse colon": "11",
                                                    "middle transverse colon": "12",
                                                    "distal transverse colon": "13",
                                                    "splenic flexure": "14",
                                                    "descending colon": "15",
                                                    "proximal descending colon": "16",
                                                    "middle descending colon": "17",
                                                    "distal descending colon": "18",
                                                    "sigmoid colon": "19",
                                                    "proximal sigmoid colon": "20",
                                                    "middle sigmoid colon": "21",
                                                    "distal sigmoid colon": "22",
                                                    "rs junction": "23",
                                                    "rectum": "24",
                                                    "upper rectum": "25",
                                                    "middle rectum": "26",
                                                    "lower rectum": "27",
                                                    "anus": "28",
                                                    "all segments of colon": "29",
                                                    "anastomosis": "30"
                                                }
                                                break;
                                            case 3: // copy from case = '2' (Colonoscopy)
                                                var temp_obj = {
                                                     "terminal ileum": "73",
                                                    "ileocecal valve": "74",
                                                    "appendix orifice": "75",
                                                    "cecum": "76",
                                                    "ascending colon": "77",
                                                    "proximal ascending colon": "78",
                                                    "middle ascending colon": "79",
                                                    "distal ascending colon": "80",
                                                    "hepatic flexure": "81",
                                                    "transverse colon": "82",
                                                    "proximal transverse colon": "83",
                                                    "middle transverse colon": "84",
                                                    "distal transverse colon": "85",
                                                    "splenic flexure": "86",
                                                    "descending colon": "87",
                                                    "proximal descending colon": "88",
                                                    "middle descending colon": "89",
                                                    "distal descending colon": "90",
                                                    "sigmoid colon": "91",
                                                    "proximal sigmoid colon": "92",
                                                    "middle sigmoid colon": "93",
                                                    "distal sigmoid colon": "94",
                                                    "rs junction": "95",
                                                    "rectum": "96",
                                                    "upper rectum": "97",
                                                    "middle rectum": "98",
                                                    "lower rectum": "99",
                                                    "anus": "100",
                                                    "all segments of colon": "101",
                                                    "anastomosis": "102"
                                                }
                                                break;
                                        }
                                        if (temp_obj[voiceInput]) {
                                            this.setExaminationColumn('insertionLevel', temp_obj[voiceInput]);
                                            if (this.getAllImages != null && this.getImage) {
                                                var item = this.getImage;
                                                var updateObj = {
                                                    imgID: item.id,
                                                    newValue: temp_obj[voiceInput],
                                                    page: 'e'
                                                };
                                                this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
                                                    .then(() => this.musicPlay('saved'));
                                            }
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "incompleteDue":
                                        var temp_obj = {
                                            "poor preparation": "1",
                                            "bleeding": "2",
                                            "bowel perforation": "3",
                                            "patient intolerance": "4",
                                            "other": "5",
                                            "food stasis": "6",
                                            "undigested medicine": "7"
                                        }
                                        if (temp_obj[voiceInput]) {
                                            this.setExaminationColumn('incompleteDue', temp_obj[voiceInput]);
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    case "switchSedative":
                                        checkInt = /^[0-9]*[1-9][0-9]*$/
                                        if (checkInt.test(voiceInput) && Number(voiceInput) > 0) {
                                            if (this.examinationSedatives[(Number(voiceInput) - 1)]) {
                                                // 設定 nowSedativesIndex
                                                this.setStoreHiddenParameter({
                                                    target: 'nowSedativesIndex',
                                                    value: (Number(voiceInput) - 1)
                                                });
                                                // 設定 focus
                                                this.setStoreHiddenParameter({
                                                    target: 'focus',
                                                    value: 'sedative'
                                                });
                                            }
                                        }
                                        resolve();
                                        break;
                                    case "sedative":
                                        // 判斷是否為數字
                                        if (isNaN(voiceInput)) {
                                            // 藥物
                                            var column = 'sedativeID';
                                            var temp_obj = {
                                                "dormicum": 1,
                                                "fentanyl": 2,
                                                "alfentanil": 3,
                                                "propofol": 4,
                                                "remifentanil": 5,
                                                "demerol": 6,
                                                "ketalar": 7,
                                                "midazolam": 8,
                                                "meperidine": 9,
                                                "alfentanyl": 10
                                            }
                                            if (temp_obj[voiceInput]) {
                                                var value = Number(temp_obj[voiceInput]);
                                                var id = this.examinationSedatives[this.getStoreHiddenParameter.nowSedativesIndex].id;
                                                this.$store.dispatch('examinations/updateExaminationSedativeColumn', {
                                                    column,
                                                    value,
                                                    id
                                                }).then(() => this.musicPlay('saved'));
                                                this.setStoreHiddenParameter({
                                                    target: 'focus',
                                                    value: ''
                                                });
                                            }
                                        } else {
                                            // 劑量
                                            var column = 'value';
                                            var value = Number(voiceInput);
                                            var id = this.examinationSedatives[this.getStoreHiddenParameter.nowSedativesIndex].id;
                                            this.$store.dispatch('examinations/updateExaminationSedativeColumn', {
                                                column,
                                                value,
                                                id
                                            }).then(() => this.musicPlay('saved'));
                                            this.setStoreHiddenParameter({
                                                target: 'focus',
                                                value: ''
                                            });
                                        }
                                        resolve();
                                        break;
                                    default:
                                        //==========================================================================
                                        //※ 第四層 Finding Options
                                        //==========================================================================                                      
                                        let uiNumber                                       
                                        switch(this.examination_typeID) {
                                            case 1:
                                                uiNumber = MapUIforFinding["Gastroscopy"][voiceInput]
                                                break
                                            case 2:
                                                uiNumber = MapUIforFinding["Colonoscopy"][voiceInput]
                                                break
                                            case 3:
                                                uiNumber = MapUIforFinding["Sigmoidoscopy"][voiceInput]
                                                break
                                        }
                                            
                                        if (uiNumber) {                                            
                                            this.$store.dispatch('examinations/addFinding', this.getExaminationData.examination.id).then(() => {
                                            if(voiceInput){
                                                let voiceInputResult = voiceInput;
                                                console.log("123 = " + voiceInputResult)
                                                this.musicPlay(`${voiceInputResult}`)
                                                setTimeout(() => { this.musicPlay('success'); }, 300);                            
                                            }                                                          

                                            // 設定 nowFindingIndex
                                            const nowFindingIndex = this.getExaminationData.findings.length - 1
                                            this.setHiddenParameter(nowFindingIndex, 0);
                                            this.setStoreHiddenParameter({
                                                target: 'over',
                                                value: false
                                            });
                                            if (this.checkInputExistAndSetFocuse("finding", "finding", "f")) {
                                                this.writeInput("finding", "s", uiNumber);
                                            }
                                            setTimeout(function() {
                                                resolve();
                                            }, 100);
                                            });                                           
                                        }
                                        
                                        resolve();                                
                                }
                        }
                }
            })
        }
    }
}
</script>
<style scoped>

  #webRTC-actions-container {
    justify-content: center;
  }
</style>
